// src/components/random-access-one/random-access-one.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
  if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _object_without_properties(source, excluded) {
  if (source == null) return {};
  var target = _object_without_properties_loose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _object_without_properties_loose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _to_consumable_array(arr) {
  return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    spotLight\n    title\n    theme\n    token\n    withBackground\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment ExperimentalSpacingFragment on ExperimentalSpacing {\n    margin\n    padding\n    marginSpace\n    paddingSpace\n    inlineMarginSpace\n    inlinePaddingSpace\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment ExperimentalAnalyticsFragment on ExperimentalAnalytics {\n    client {\n      eventType\n      linkName\n      referrerId\n      uisPrimeMessages {\n        __typename\n        schemaName\n        messageContent\n      }\n    }\n    appendToReferrerId\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment ExperimentalTabFragment on ExperimentalTab {\n    title\n    target\n    disabled\n    analytics {\n      __typename\n      appendToReferrerId\n      ...ExperimentalAnalyticsFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment ExperimentalSubTitleFragment on ExperimentalInfoSectionSubTitle {\n    text {\n      text\n      theme\n      weight\n      size\n    }\n    icon {\n      ...EGDSIconFragment\n    }\n    space\n    overflow\n  }\n\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment ExperimentalLinkActionFragment on ExperimentalLinkAction {\n    url\n    target\n    clickEvent {\n      eventType\n      referrerId\n      linkName\n    }\n    modal {\n      id\n      queryKey\n    }\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment ExperimentalScriptFragment on ExperimentalScript {\n    variables {\n      name\n      expression\n    }\n    expression\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment CardConfigFragment on ExperimentalCardConfig {\n    featuredHeader {\n      text\n      tag\n    }\n    featuredImage {\n      description\n      url\n      aspectRatio\n    }\n    link {\n      text\n      action {\n        ...ExperimentalLinkActionFragment\n      }\n    }\n    overflow\n    padded\n    border\n    selected\n    background\n  }\n\n  ", "\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment CarouselConfigFragment on ExperimentalCarouselConfig {\n    hideNav\n    itemsVisible {\n      sm\n      md\n      lg\n      xl\n    }\n    nextButton\n    prevButton\n    imagesList {\n      description\n      url\n    }\n    peek\n    alwaysShowPaging\n    analytics {\n      viewed {\n        eventType\n        linkName\n        referrerId\n      }\n      scrollEvent {\n        eventType\n        linkName\n        referrerId\n      }\n    }\n    naturalWidth\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment ImpressionTrackerFragment on ExperimentalImpressionTracker {\n    analytics {\n      eventType\n      linkName\n      referrerId\n      uisPrimeMessages {\n        __typename\n        schemaName\n        messageContent\n      }\n    }\n    trackOnce\n  }\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment TextInfoLinkFragment on ExperimentalAction {\n    type\n    data {\n      text\n      action {\n        url\n        target\n        modal {\n          id\n          queryKey\n        }\n      }\n      icon {\n        ...EGDSIconFragment\n      }\n      iconPosition\n      inlineSpace\n    }\n    analytics {\n      ...ExperimentalAnalyticsFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment ContainerFragment on ExperimentalContainerConfig {\n    action {\n      ...TextInfoLinkFragment\n    }\n    flex {\n      direction\n      horizontal\n      vertical\n    }\n    impression {\n      ...ImpressionTrackerFragment\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment ExpandoFragment on ExperimentalExpandoConfig {\n    isList\n    expandLabel\n    collapseLabel\n    linesToShow\n    itemsToShow\n    hideScrim\n    analytics {\n      ...ExperimentalAnalyticsFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment IntersectionTrackerFragment on ExperimentalIntersectionTracker {\n    analytics {\n      eventType\n      linkName\n      referrerId\n      uisPrimeMessages {\n        __typename\n        schemaName\n        messageContent\n      }\n    }\n    trackOnce\n  }\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment LayoutGridFragment on ExperimentalLayoutGrid {\n    columns\n    space\n    gridItem {\n      colSpan\n    }\n  }\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment ExperimentalImageFragment on ExperimentalImage {\n    source\n    description\n    aspectRatio\n    imageFit\n    lazyLoading\n    placeholder\n    roundedCorner\n    useBlank\n    events {\n      ...ExperimentalAnalyticsFragment\n    }\n    actions {\n      type\n      data {\n        action {\n          ...ExperimentalLinkActionFragment\n        }\n        text\n      }\n    }\n  }\n\n  ", "\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment MediaConfigFragment on ExperimentalMediaConfig {\n    image {\n      ...ExperimentalImageFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  fragment ModalConfigFragment on ExperimentalModalConfig {\n    modalId {\n      id\n      queryKey\n    }\n    type\n    fullWidth\n    isExpanded\n    position\n    sideSheetLayout\n    toolbar {\n      title\n      navType\n      closeLabel\n      analytics {\n        ...ExperimentalAnalyticsFragment\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment RatingFragment on ExperimentalRatingConfig {\n    iconId\n    rating\n    accessibility\n  }\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  ", "\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment SpacingFragment on ExperimentalSpacing {\n    margin\n    padding\n    marginSpace\n    paddingSpace\n    inlineMarginSpace\n    inlinePaddingSpace\n  }\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  fragment TabsConfigFragment on ExperimentalTabsConfig {\n    selectedIndex\n    border\n    type\n    scrollTo\n    isJumpLink\n    tabs {\n      ...ExperimentalTabFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject22() {
  var data = _tagged_template_literal(["\n  fragment ExperimentalButtonFragment on ExperimentalButton {\n    type\n    action {\n      ...TextInfoLinkFragment\n    }\n    isFullWidth\n  }\n\n  ", "\n"]);
  _templateObject22 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject23() {
  var data = _tagged_template_literal(["\n  fragment TextInfoSectionFragment on ExperimentalInfoSection {\n    badge {\n      text\n      theme\n    }\n    title {\n      text {\n        text\n        size\n      }\n      attributes {\n        tag\n        ariaHidden\n      }\n      icon {\n        ...EGDSIconFragment\n      }\n      spacing {\n        ...ExperimentalSpacingFragment\n      }\n      overflow\n    }\n    subTitle {\n      text {\n        text\n        theme\n        weight\n        size\n      }\n      icon {\n        ...EGDSIconFragment\n      }\n      space\n      overflow\n    }\n    descriptions {\n      showAsList\n      texts\n      paragraphSize\n      inheritParagraphStyling\n    }\n    links {\n      ...TextInfoLinkFragment\n    }\n    buttons {\n      type\n      action {\n        ...TextInfoLinkFragment\n      }\n      isFullWidth\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject23 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject24() {
  var data = _tagged_template_literal(["\n  fragment EGDSGraphicTextFragment on EGDSGraphicText {\n    text\n    graphic {\n      ...EGDSIconFragment\n      ... on Mark {\n        url {\n          ... on HttpURI {\n            value\n          }\n        }\n      }\n    }\n  }\n\n  ", "\n"]);
  _templateObject24 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject25() {
  var data = _tagged_template_literal(["\n  fragment EGDSInlineLinkFragment on EGDSInlineLink {\n    action {\n      accessibility\n      analytics {\n        linkName\n        referrerId\n      }\n      resource {\n        value\n      }\n      target\n    }\n    disabled\n    linkSize: size\n    text\n  }\n"]);
  _templateObject25 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject26() {
  var data = _tagged_template_literal(["\n  fragment EGDSHeadingFragment on EGDSHeading {\n    accessibility\n    text\n  }\n"]);
  _templateObject26 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject27() {
  var data = _tagged_template_literal(["\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    accessibility\n    decorative\n    size\n    text\n    theme\n    weight\n  }\n"]);
  _templateObject27 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject28() {
  var data = _tagged_template_literal(["\n  fragment EGDSPlainTextFragment on EGDSPlainText {\n    text\n    accessibility\n  }\n"]);
  _templateObject28 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject29() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextContentFragment on EGDSText {\n    ...EGDSHeadingFragment\n    ...EGDSStylizedTextFragment\n    ...EGDSPlainTextFragment\n    ...EGDSGraphicTextFragment\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject29 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject30() {
  var data = _tagged_template_literal(["\n  fragment EGDSSpannableTextFragment on EGDSSpannableText {\n    text\n    inlineContent {\n      ...EGDSSpannableTextContentFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject30 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject31() {
  var data = _tagged_template_literal(["\n  fragment ProductTextInfoContentFragment on ProductSupportingMessage {\n    ... on EGDSPlainText {\n      ...EGDSPlainTextFragment\n    }\n    ... on EGDSInlineLink {\n      ...EGDSInlineLinkFragment\n    }\n    ... on EGDSGraphicText {\n      ...EGDSGraphicTextFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject31 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject32() {
  var data = _tagged_template_literal(["\n  fragment ProductTextInfoSectionFragment on ProductTextInfoSection {\n    title {\n      text\n      weight\n      theme\n      accessibility\n    }\n    tooltipContent\n    tooltipIcon {\n      id\n      title\n      size\n      theme\n    }\n    policyA11yText\n    icon {\n      description\n      id\n      token\n      theme\n      size\n    }\n    accessibilityText\n    theme\n    message {\n      title\n      content {\n        ... on EGDSPlainText {\n          ...EGDSPlainTextFragment\n        }\n        ... on EGDSInlineLink {\n          ...EGDSInlineLinkFragment\n        }\n        ... on EGDSGraphicText {\n          ...EGDSGraphicTextFragment\n        }\n      }\n      openAnalytics {\n        eventType\n        linkName\n        referrerId\n      }\n    }\n  }\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject32 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject33() {
  var data = _tagged_template_literal(["\n  ", "\n"]);
  _templateObject33 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject34() {
  var data = _tagged_template_literal(["\n  fragment ExperimentalConfigFragment on ExperimentalConfig {\n    card {\n      ...CardConfigFragment\n    }\n    infoSection {\n      ...TextInfoSectionFragment\n    }\n    grid {\n      ...LayoutGridFragment\n    }\n    spacing {\n      ...SpacingFragment\n    }\n    carousel {\n      ...CarouselConfigFragment\n    }\n    rating {\n      ...RatingFragment\n    }\n    expando {\n      ...ExpandoFragment\n    }\n    intersection {\n      ...IntersectionTrackerFragment\n    }\n    textIconTooltip {\n      ...ProductTextInfoSectionFragment\n    }\n    tabs {\n      ...TabsConfigFragment\n    }\n    modal {\n      ...ModalConfigFragment\n    }\n    media {\n      ...MediaConfigFragment\n    }\n    script {\n      ...ExperimentalScriptFragment\n    }\n    container {\n      ...ContainerFragment\n    }\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject34 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject35() {
  var data = _tagged_template_literal(["\n  query RandomAccessOneExperimentalQuery($context: ContextInput!, $productIdentifier: ProductIdentifierInput!, $featureId: String!) {\n    randomAccessOne(context: $context, featureId: $featureId, productIdentifier: $productIdentifier) {\n      id\n      mapping {\n        ...ExperimentalComponentWrapperFragment\n      }\n      metadata {\n        ...ExperimentalExperimentalMetadataFragment\n      }\n    }\n  }\n\n  fragment ExperimentalExperimentalMetadataFragment on ExperimentalMetadata {\n    id\n    signalEvents {\n      id\n      successEvent {\n        linkName\n        referrerId\n        uisPrimeMessages {\n          messageContent\n          schemaName\n        }\n      }\n    }\n  }\n\n  fragment ExperimentalComponentWrapperFragment on ExperimentalComponentWrapper {\n    id\n    childrenIds\n    element {\n      ...ComponentFragment\n    }\n  }\n\n  fragment ComponentFragment on ExperimentalComponent {\n    type\n    typeClass\n    metadata {\n      id\n    }\n    config {\n      ...ExperimentalConfigFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject35 = function _templateObject() {
    return data;
  };
  return data;
}
import React41, { useContext as useContext2 } from "react";
import { gql as gql31, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { ProductGalleryContext as ProductGalleryContext2 } from "@shared-ui/retail-product-gallery";
// src/components/random-access-one/utils/adaptex-events.ts
import { useContext } from "react";
import { useClickstreamAnalytics } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { ProductGalleryContext } from "@shared-ui/retail-product-gallery";
// src/library/analytics.ts
import { ITrackType } from "@shared-ui/clickstream-analytics-context";
var trackClick = function (clickTracker, referrerId, linkName, uisMicroMessage) {
  var delay = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
  clickTracker(referrerId, linkName, delay, uisMicroMessage);
};
var trackAnalytics = function (clickstreamAnalytics, analytics, eventType) {
  var trackType = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ITrackType.EVENT;
  var track = clickstreamAnalytics.track;
  var uisPrimeMessages = analytics.uisPrimeMessages,
    referrerId = analytics.referrerId,
    linkName = analytics.linkName;
  var message = {
    schemaName: "referrer",
    messageContent: {
      eventType: eventType,
      linkName: linkName,
      referrerId: referrerId
    }
  };
  var messages = [message];
  uisPrimeMessages === null || uisPrimeMessages === void 0 ? void 0 : uisPrimeMessages.forEach(function (value) {
    messages.push({
      schemaName: value.schemaName,
      messageContent: JSON.parse(value.messageContent)
    });
  });
  track(trackType, {
    data: messages
  });
};
// src/components/random-access-one/utils/adaptex-events.ts
var adaptexCampaignList = ["image_mosaic_adaptex"];
var handleAdaptexEvents = function (featureId, data) {
  var _data_randomAccessOne_metadata, _data_randomAccessOne, _data_randomAccessOne1;
  var clickstreamAnalytics = useClickstreamAnalytics();
  var _useContext = useContext(ProductGalleryContext),
    setAdaptExState = _useContext.setAdaptExState,
    eventType = _useContext.eventType;
  var _useExperiment = useExperiment("Adaptex_campaign_PDP_mosaic_for_large_screens"),
    imageMosaicLargeScreensExposure = _useExperiment.exposure;
  var _useExperiment1 = useExperiment("Adaptex_campaign_PDP_mosaic_for_small_screens"),
    imageMosaicMWebExposure = _useExperiment1.exposure;
  var adaptexCampaignVariant = imageMosaicLargeScreensExposure.bucket === 1 || imageMosaicMWebExposure.bucket === 1;
  var isMatchedTest = adaptexCampaignList.includes(featureId);
  var isControlArm = data === null || data === void 0 ? void 0 : (_data_randomAccessOne = data.randomAccessOne) === null || _data_randomAccessOne === void 0 ? void 0 : (_data_randomAccessOne_metadata = _data_randomAccessOne.metadata) === null || _data_randomAccessOne_metadata === void 0 ? void 0 : _data_randomAccessOne_metadata.id.includes("arm_0");
  var mappingNotEmpty = data === null || data === void 0 ? void 0 : (_data_randomAccessOne1 = data.randomAccessOne) === null || _data_randomAccessOne1 === void 0 ? void 0 : _data_randomAccessOne1.mapping.length;
  if (!adaptexCampaignVariant || !isMatchedTest) {
    return;
  }
  if (isControlArm) {
    setAdaptExState(true);
  }
  if (mappingNotEmpty && eventType) {
    var _data_randomAccessOne_metadata_signalEvents, _data_randomAccessOne_metadata1, _data_randomAccessOne2, _matchedSignalEvent_;
    var matchedSignalEvent = data === null || data === void 0 ? void 0 : (_data_randomAccessOne2 = data.randomAccessOne) === null || _data_randomAccessOne2 === void 0 ? void 0 : (_data_randomAccessOne_metadata1 = _data_randomAccessOne2.metadata) === null || _data_randomAccessOne_metadata1 === void 0 ? void 0 : (_data_randomAccessOne_metadata_signalEvents = _data_randomAccessOne_metadata1.signalEvents) === null || _data_randomAccessOne_metadata_signalEvents === void 0 ? void 0 : _data_randomAccessOne_metadata_signalEvents.filter(function (event) {
      return event.id === eventType;
    });
    var successEvent = matchedSignalEvent === null || matchedSignalEvent === void 0 ? void 0 : (_matchedSignalEvent_ = matchedSignalEvent[0]) === null || _matchedSignalEvent_ === void 0 ? void 0 : _matchedSignalEvent_.successEvent;
    if (matchedSignalEvent && successEvent) {
      var isImpression = successEvent.linkName.includes("impression");
      if (isControlArm && isImpression) {
        trackAnalytics(clickstreamAnalytics, successEvent, "impression");
      } else {
        trackAnalytics(clickstreamAnalytics, successEvent, "click");
      }
    }
  }
};
// src/components/random-access-one/utils/util.ts
import { useCallback } from "react";
import { useHistory } from "react-router-dom";
var reduceArray = function (elementsList, parent, remainingElements) {
  elementsList.forEach(function (node) {
    var _node_childrenIds;
    if (!remainingElements[node.id]) {
      return;
    }
    var newElement = _object_spread_props(_object_spread({}, node.element), {
      children: []
    });
    delete remainingElements[node.id];
    if (node === null || node === void 0 ? void 0 : (_node_childrenIds = node.childrenIds) === null || _node_childrenIds === void 0 ? void 0 : _node_childrenIds.length) {
      var list = [];
      node.childrenIds.forEach(function (childId) {
        list.push(_object_spread_props(_object_spread({}, remainingElements[childId]), {
          children: []
        }));
      });
      reduceArray(list, newElement.children, remainingElements);
    }
    parent.push(newElement);
  });
};
var getAllElementsMap = function (list) {
  var mappedList = {};
  list.forEach(function (node) {
    mappedList[node.id] = node;
  });
  return mappedList;
};
var toTemplateResponse = function (data) {
  var components = [];
  var elementsList = _to_consumable_array(data.randomAccessOne.mapping);
  reduceArray(elementsList, components, getAllElementsMap(elementsList));
  return components;
};
function useUpdateUrl() {
  var history = useHistory();
  return useCallback(function (keyAndValue) {
    if (history && keyAndValue.includes("=")) {
      var paramsParts = keyAndValue.split("=");
      var params = new URLSearchParams(history.location.search);
      if ((paramsParts === null || paramsParts === void 0 ? void 0 : paramsParts[0]) && paramsParts[1]) {
        params.set(paramsParts[0], String(paramsParts[1]));
      }
      history.replace("".concat(history.location.pathname, "?").concat(params));
    }
  }, [history]);
}
function extractField(str, splitValue, field) {
  if (!str.includes(splitValue)) {
    return str;
  }
  var parts = str.split(splitValue);
  return parts[field] || "";
}
// src/__generated__/types.ts
var ExperimentalElements = /* @__PURE__ */function (ExperimentalElements2) {
  ExperimentalElements2["Card"] = "Card";
  ExperimentalElements2["Carousel"] = "Carousel";
  ExperimentalElements2["Clickable"] = "Clickable";
  ExperimentalElements2["Container"] = "Container";
  ExperimentalElements2["Expando"] = "Expando";
  ExperimentalElements2["Grid"] = "Grid";
  ExperimentalElements2["InfoSection"] = "InfoSection";
  ExperimentalElements2["IntersectionTracker"] = "IntersectionTracker";
  ExperimentalElements2["Media"] = "Media";
  ExperimentalElements2["Modal"] = "Modal";
  ExperimentalElements2["Rating"] = "Rating";
  ExperimentalElements2["Script"] = "Script";
  ExperimentalElements2["Spacing"] = "Spacing";
  ExperimentalElements2["Tabs"] = "Tabs";
  ExperimentalElements2["TextIconTooltip"] = "TextIconTooltip";
  return ExperimentalElements2;
}(ExperimentalElements || {});
var IdentifierType = /* @__PURE__ */function (IdentifierType2) {
  IdentifierType2["ACTIVITY_ID"] = "ACTIVITY_ID";
  IdentifierType2["CART_ID"] = "CART_ID";
  IdentifierType2["CHECKOUT_SESSION_ID"] = "CHECKOUT_SESSION_ID";
  IdentifierType2["ENTITY_ID"] = "ENTITY_ID";
  IdentifierType2["LEGACY_ORDER_ID"] = "LEGACY_ORDER_ID";
  IdentifierType2["OFFER_ID"] = "OFFER_ID";
  IdentifierType2["ORDER_ID"] = "ORDER_ID";
  IdentifierType2["PROPERTY_ID"] = "PROPERTY_ID";
  IdentifierType2["SAILING_TOKEN"] = "SAILING_TOKEN";
  return IdentifierType2;
}(IdentifierType || {});
// src/library/elements/card/index.tsx
import React5 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkFigure, UitkFigureAspectRatioType as UitkFigureAspectRatioType2, UitkImage } from "@egds/react-core/images";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkCard, UitkCardContentSection, UitkCardLink as UitkCardLink2 } from "uitk-react-cards";
// src/library/mapper/card-background-mapper.ts
var CardThemeMap = {
  primary: "primary",
  secondary: "secondary",
  highlight: "highlight",
  "global-loyalty-extra-high": "global-loyalty-extra-high",
  "global-loyalty-high": "global-loyalty-high",
  "global-loyalty-low": "global-loyalty-low",
  "global-loyalty-middle": "global-loyalty-middle",
  "global-loyalty-standard": "global-loyalty-standard",
  default: void 0
};
// src/library/mapper/media-mapper.ts
import { UitkFigureAspectRatioType } from "@egds/react-core/images";
var _obj;
var AspectRatioMap = (_obj = {}, _define_property(_obj, "FOUR_ONE" /* FOUR_ONE */, UitkFigureAspectRatioType.R4_1), _define_property(_obj, "FOUR_THREE" /* FOUR_THREE */, UitkFigureAspectRatioType.R4_3), _define_property(_obj, "ONE_ONE" /* ONE_ONE */, UitkFigureAspectRatioType.R1_1), _define_property(_obj, "SIXTEEN_NINE" /* SIXTEEN_NINE */, UitkFigureAspectRatioType.R16_9), _define_property(_obj, "THREE_FOUR" /* THREE_FOUR */, UitkFigureAspectRatioType.R3_4), _define_property(_obj, "THREE_TWO" /* THREE_TWO */, UitkFigureAspectRatioType.R3_2), _define_property(_obj, "TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */, UitkFigureAspectRatioType.R21_9), _obj);
var _obj1;
var ImageFitMap = (_obj1 = {}, _define_property(_obj1, "CONTAIN" /* CONTAIN */, "contain"), _define_property(_obj1, "COVER" /* COVER */, "cover"), _obj1);
var _obj2;
var LazyloadingMap = (_obj2 = {}, _define_property(_obj2, "EAGER" /* EAGER */, "eager"), _define_property(_obj2, "LAZY" /* LAZY */, "lazy"), _define_property(_obj2, "OFF" /* OFF */, "off"), _obj2);
var _obj3;
var RoundedCornerMap = (_obj3 = {}, _define_property(_obj3, "TRUE" /* TRUE */, true), _define_property(_obj3, "FALSE" /* FALSE */, false), _define_property(_obj3, "ALL" /* ALL */, ["all"]), _define_property(_obj3, "MAX" /* MAX */, ["max"]), _define_property(_obj3, "START_START" /* START_START */, ["startstart", "startstart"]), _define_property(_obj3, "START_END" /* START_END */, ["startend", "startend"]), _define_property(_obj3, "END_START" /* END_START */, ["endstart", "endstart"]), _define_property(_obj3, "END_END" /* END_END */, ["endend", "endend"]), _obj3);
// src/library/types.tsx
import React3 from "react";
import { gql as gql2 } from "@apollo/client";
// ../internal/src/components/egds-icon/egds-icon.tsx
import React2 from "react";
import { gql } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "@egds/react-core/icons";
var _obj4;
// ../internal/src/components/egds-icon/__private/spotlight-mapper.ts
var spotlightMapper = (_obj4 = {}, _define_property(_obj4, "INFO" /* INFO */, "info"), _define_property(_obj4, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj4, "WARNING" /* WARNING */, "warning"), _define_property(_obj4, "STANDARD" /* STANDARD */, "standard"), _obj4);
// ../internal/src/components/egds-icon/egds-icon.tsx
var fragment = gql(_templateObject());
var EGDSIcon = function (param) {
  var className = param.className,
    defaultIconSize = param.defaultIconSize,
    data = param.data,
    spotlight = param.spotlight;
  var id = data.id,
    token = data.token;
  if (!id || !token) {
    return null;
  }
  var description = data.description,
    withBackground = data.withBackground,
    size = data.size,
    spotLightData = data.spotLight,
    title = data.title,
    theme = data.theme;
  return /* @__PURE__ */React2.createElement(UitkIcon, {
    className: className,
    description: description,
    id: id,
    name: token,
    shadow: withBackground !== null && withBackground !== void 0 ? withBackground : void 0,
    size: size ? UitkIconSize[size] : defaultIconSize,
    spotlight: spotLightData ? spotlightMapper[spotLightData] : spotlight,
    title: title !== null && title !== void 0 ? title : void 0,
    theme: theme !== null && theme !== void 0 ? theme : void 0
  });
};
EGDSIcon.fragment = fragment;
EGDSIcon.displayName = "UitkIcon";
// src/library/types.tsx
var __ExperimentalSpacingFragment = gql2(_templateObject1());
var ExperimentalSpacing = function () {
  return /* @__PURE__ */React3.createElement("div", null, "ExperimentalSpacing.fragment");
};
ExperimentalSpacing.displayName = "ExperimentalSpacing";
ExperimentalSpacing.fragment = __ExperimentalSpacingFragment;
var __ExperimentalAnalyticsFragment = gql2(_templateObject2());
var ExperimentalAnalytics = function () {
  return /* @__PURE__ */React3.createElement("div", null, "ExperimentalAnalytics.fragment");
};
ExperimentalAnalytics.displayName = "ExperimentalAnalytics";
ExperimentalAnalytics.fragment = __ExperimentalAnalyticsFragment;
var __ExperimentalTabFragment = gql2(_templateObject3(), ExperimentalAnalytics.fragment);
var ExperimentalTab = function () {
  return /* @__PURE__ */React3.createElement("div", null, "ExperimentalTab.fragment");
};
ExperimentalTab.displayName = "ExperimentalTab";
ExperimentalTab.fragment = __ExperimentalTabFragment;
var __ExperimentalSubtitleFragment = gql2(_templateObject4(), EGDSIcon.fragment);
var ExperimentalSubtitle = function () {
  return /* @__PURE__ */React3.createElement("div", null, "ExperimentalSubTitle.fragment");
};
ExperimentalSubtitle.displayName = "ExperimentalSubtitle";
ExperimentalSubtitle.fragment = __ExperimentalSubtitleFragment;
var __ExperimentalLinkActionFragment = gql2(_templateObject5());
var ExperimentalLinkAction = function () {
  return /* @__PURE__ */React3.createElement("div", null, "ExperimentalLinkAction.fragment");
};
ExperimentalLinkAction.displayName = "ExperimentalLinkAction";
ExperimentalLinkAction.fragment = __ExperimentalLinkActionFragment;
var __ExperimentalScriptFragment = gql2(_templateObject6());
var ExperimentalScript = function () {
  return /* @__PURE__ */React3.createElement("div", null, "ExperimentalScript.fragment");
};
ExperimentalScript.displayName = "ExperimentalScript";
ExperimentalScript.fragment = __ExperimentalScriptFragment;
// src/library/elements/card/modal.tsx
import React4 from "react";
import { useDialog } from "@shared-ui/dialog-context";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkCardLink } from "uitk-react-cards";
var CardModalTrigger = function (param) {
  var modalId = param.modalId,
    queryKey = param.queryKey,
    text = param.text,
    onClick = param.onClick;
  var _useDialog = _sliced_to_array(useDialog(modalId, queryKey), 2),
    dialogActions = _useDialog[1];
  var openDialog = function () {
    dialogActions.openDialog();
    if (onClick) {
      onClick();
    }
  };
  return /* @__PURE__ */React4.createElement(UitkCardLink, null, /* @__PURE__ */React4.createElement(UitkTertiaryButton, {
    role: "button",
    tag: "a",
    onClick: openDialog
  }, text));
};
// src/library/elements/card/index.tsx
import { ExperienceTemplateRenderer } from "experience-template-renderer-react";
var __CardConfigFragment = gql3(_templateObject7(), ExperimentalLinkAction.fragment);
var Card = function (param) {
  var templateComponent = param.templateComponent;
  var _card_featuredImage, _templateComponent_metadata, _card_link_action, _card_link, _card_link_action1, _card_link_action2, _card_link1, _card_link_action3, _card_link2, _card_link_action4, _card_link3, _card_link4;
  var children = templateComponent.children;
  var config = templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.config;
  var card = config.card;
  var backgroundTheme = card.background ? CardThemeMap[card.background] : void 0;
  var aspectRatio = ((_card_featuredImage = card.featuredImage) === null || _card_featuredImage === void 0 ? void 0 : _card_featuredImage.aspectRatio) ? AspectRatioMap[card.featuredImage.aspectRatio] : UitkFigureAspectRatioType2.R16_9;
  var clickTracker = useClickTracker();
  var sendAnalytics2 = function (analytics) {
    if (analytics) {
      var referrerId = analytics.referrerId,
        linkName = analytics.linkName;
      trackClick(clickTracker, referrerId, linkName);
    }
  };
  var _card_padded, _card_border, _card_overflow;
  return card ? /* @__PURE__ */React5.createElement(UitkCard, {
    "data-view-id": (_templateComponent_metadata = templateComponent.metadata) === null || _templateComponent_metadata === void 0 ? void 0 : _templateComponent_metadata.id,
    padded: (_card_padded = card.padded) !== null && _card_padded !== void 0 ? _card_padded : false,
    border: (_card_border = card.border) !== null && _card_border !== void 0 ? _card_border : false,
    overflow: (_card_overflow = card.overflow) !== null && _card_overflow !== void 0 ? _card_overflow : false,
    backgroundTheme: backgroundTheme
  }, card.featuredImage && /* @__PURE__ */React5.createElement(UitkFigure, {
    ratio: aspectRatio
  }, /* @__PURE__ */React5.createElement(UitkImage, {
    alt: card.featuredImage.description,
    src: card.featuredImage.url
  })), ((_card_link = card.link) === null || _card_link === void 0 ? void 0 : (_card_link_action = _card_link.action) === null || _card_link_action === void 0 ? void 0 : _card_link_action.url) && /* @__PURE__ */React5.createElement(UitkCardLink2, null, /* @__PURE__ */React5.createElement("a", {
    href: (_card_link_action1 = card.link.action) === null || _card_link_action1 === void 0 ? void 0 : _card_link_action1.url
  }, card.link.text)), ((_card_link1 = card.link) === null || _card_link1 === void 0 ? void 0 : (_card_link_action2 = _card_link1.action) === null || _card_link_action2 === void 0 ? void 0 : _card_link_action2.modal) && /* @__PURE__ */React5.createElement(CardModalTrigger, {
    modalId: (_card_link2 = card.link) === null || _card_link2 === void 0 ? void 0 : (_card_link_action3 = _card_link2.action) === null || _card_link_action3 === void 0 ? void 0 : _card_link_action3.modal.id,
    queryKey: ((_card_link3 = card.link) === null || _card_link3 === void 0 ? void 0 : (_card_link_action4 = _card_link3.action) === null || _card_link_action4 === void 0 ? void 0 : _card_link_action4.modal.queryKey) || void 0,
    text: (_card_link4 = card.link) === null || _card_link4 === void 0 ? void 0 : _card_link4.text,
    onClick: function () {
      var _card_link_action, _card_link, _card_link_action1, _card_link1;
      return ((_card_link = card.link) === null || _card_link === void 0 ? void 0 : (_card_link_action = _card_link.action) === null || _card_link_action === void 0 ? void 0 : _card_link_action.clickEvent) && sendAnalytics2((_card_link1 = card.link) === null || _card_link1 === void 0 ? void 0 : (_card_link_action1 = _card_link1.action) === null || _card_link_action1 === void 0 ? void 0 : _card_link_action1.clickEvent);
    }
  }), children && children.length > 0 ? /* @__PURE__ */React5.createElement(UitkCardContentSection, null, /* @__PURE__ */React5.createElement(ExperienceTemplateRenderer, {
    templateComponents: children
  })) : /* @__PURE__ */React5.createElement("div", null)) : null;
};
Card.displayName = "Card";
Card.fragment = __CardConfigFragment;
// src/library/elements/carousel/carousel.tsx
import React6 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkFigure as UitkFigure2, UitkFigureAspectRatioType as UitkFigureAspectRatioType3, UitkImage as UitkImage2 } from "@egds/react-core/images";
import { useClickstreamAnalytics as useClickstreamAnalytics2, useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkCarousel } from "uitk-react-carousel";
// src/library/elements/carousel/default-carousel-props.ts
var carouselDefaultProps = {
  carouselHeaderText: "ExperimentalCarousel",
  carouselName: "ExperimentalCarousel",
  loop: true,
  itemsVisible: {
    sm: 1,
    md: 1,
    lg: 1,
    xl: 1
  },
  pageBy: 1,
  pagingInset: true,
  pagingOverlay: false,
  wrapItems: true,
  navigationIconId: {
    next: "next-button-gallery",
    prev: "prev-button-gallery"
  },
  buttonText: {
    nextButton: "Show next card",
    prevButton: "Show previous card"
  },
  children: null
};
// src/library/elements/carousel/carousel.tsx
import { ExperienceTemplateRenderer as ExperienceTemplateRenderer2 } from "experience-template-renderer-react";
var __CarouselConfigFragment = gql4(_templateObject8());
var Carousel = function (param) {
  var templateComponent = param.templateComponent;
  var _carousel_itemsVisible, _carousel_itemsVisible1, _carousel_itemsVisible2, _carousel_itemsVisible3, _carousel_imagesList, _templateComponent_metadata;
  var children = templateComponent.children;
  var config = templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.config;
  var carousel = config.carousel;
  var clickTracker = useClickTracker2();
  var clickstreamAnalytics = useClickstreamAnalytics2();
  var carouselProps = _object_spread_props(_object_spread({}, carouselDefaultProps), {
    itemsVisible: {
      sm: (carousel === null || carousel === void 0 ? void 0 : (_carousel_itemsVisible = carousel.itemsVisible) === null || _carousel_itemsVisible === void 0 ? void 0 : _carousel_itemsVisible.sm) || carouselDefaultProps.itemsVisible.sm,
      md: (carousel === null || carousel === void 0 ? void 0 : (_carousel_itemsVisible1 = carousel.itemsVisible) === null || _carousel_itemsVisible1 === void 0 ? void 0 : _carousel_itemsVisible1.md) || carouselDefaultProps.itemsVisible.md,
      lg: (carousel === null || carousel === void 0 ? void 0 : (_carousel_itemsVisible2 = carousel.itemsVisible) === null || _carousel_itemsVisible2 === void 0 ? void 0 : _carousel_itemsVisible2.lg) || carouselDefaultProps.itemsVisible.lg,
      xl: (carousel === null || carousel === void 0 ? void 0 : (_carousel_itemsVisible3 = carousel.itemsVisible) === null || _carousel_itemsVisible3 === void 0 ? void 0 : _carousel_itemsVisible3.xl) || carouselDefaultProps.itemsVisible.xl
    },
    hideNav: carousel === null || carousel === void 0 ? void 0 : carousel.hideNav,
    peek: carousel === null || carousel === void 0 ? void 0 : carousel.peek,
    pagingPersistent: carousel === null || carousel === void 0 ? void 0 : carousel.alwaysShowPaging,
    buttonText: {
      prevButton: (carousel === null || carousel === void 0 ? void 0 : carousel.prevButton) || carouselDefaultProps.buttonText.prevButton,
      nextButton: (carousel === null || carousel === void 0 ? void 0 : carousel.nextButton) || carouselDefaultProps.buttonText.nextButton
    },
    itemsMaxHeight: true,
    naturalWidthItems: carousel === null || carousel === void 0 ? void 0 : carousel.naturalWidth,
    onIndexChange: function () {
      var _carousel_analytics, _carousel_analytics1;
      if (!(carousel === null || carousel === void 0 ? void 0 : (_carousel_analytics = carousel.analytics) === null || _carousel_analytics === void 0 ? void 0 : _carousel_analytics.viewed)) {
        return;
      }
      trackAnalytics(clickstreamAnalytics, (_carousel_analytics1 = carousel.analytics) === null || _carousel_analytics1 === void 0 ? void 0 : _carousel_analytics1.viewed, "impression");
    },
    analytics: {
      callback: function callback(id) {
        var _carousel_analytics;
        if (!(carousel === null || carousel === void 0 ? void 0 : (_carousel_analytics = carousel.analytics) === null || _carousel_analytics === void 0 ? void 0 : _carousel_analytics.scrollEvent)) {
          return;
        }
        if (id.endsWith("scrollRight")) {
          var _carousel_analytics_scrollEvent, _carousel_analytics_scrollEvent1;
          trackClick(clickTracker, "".concat((_carousel_analytics_scrollEvent = carousel.analytics.scrollEvent) === null || _carousel_analytics_scrollEvent === void 0 ? void 0 : _carousel_analytics_scrollEvent.referrerId, ".scrollRight"), "".concat((_carousel_analytics_scrollEvent1 = carousel.analytics.scrollEvent) === null || _carousel_analytics_scrollEvent1 === void 0 ? void 0 : _carousel_analytics_scrollEvent1.linkName));
        } else if (id.endsWith("scrollLeft")) {
          var _carousel_analytics_scrollEvent2, _carousel_analytics_scrollEvent3;
          trackClick(clickTracker, "".concat((_carousel_analytics_scrollEvent2 = carousel.analytics.scrollEvent) === null || _carousel_analytics_scrollEvent2 === void 0 ? void 0 : _carousel_analytics_scrollEvent2.referrerId, ".scrollLeft"), "".concat((_carousel_analytics_scrollEvent3 = carousel.analytics.scrollEvent) === null || _carousel_analytics_scrollEvent3 === void 0 ? void 0 : _carousel_analytics_scrollEvent3.linkName));
        }
      },
      id: "fasttrack-carousel-id",
      description: "fasttrack-carousel-description"
    }
  });
  var images = carousel === null || carousel === void 0 ? void 0 : (_carousel_imagesList = carousel.imagesList) === null || _carousel_imagesList === void 0 ? void 0 : _carousel_imagesList.map(function (image, index) {
    return /* @__PURE__ */React6.createElement(UitkFigure2, {
      ratio: UitkFigureAspectRatioType3.R16_9,
      roundcorner: true,
      key: "carousel-item-".concat(index)
    }, /* @__PURE__ */React6.createElement(UitkImage2, {
      alt: image.description,
      src: image.url
    }));
  });
  var cards = children === null || children === void 0 ? void 0 : children.map(function (child, i) {
    return /* @__PURE__ */React6.createElement(ExperienceTemplateRenderer2, {
      key: "carousel-child-".concat(i),
      templateComponents: [child]
    });
  });
  return images || cards ? /* @__PURE__ */React6.createElement("div", {
    "data-view-id": (_templateComponent_metadata = templateComponent.metadata) === null || _templateComponent_metadata === void 0 ? void 0 : _templateComponent_metadata.id
  }, /* @__PURE__ */React6.createElement(UitkCarousel, _object_spread({}, carouselProps), images, cards)) : null;
};
Carousel.displayName = "Carousel";
Carousel.fragment = __CarouselConfigFragment;
// src/library/elements/container.tsx
import React10 from "react";
import { gql as gql7 } from "@apollo/client";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
var _obj5;
// src/library/mapper/container-flex-mapper.ts
var flexVerticalConverter = (_obj5 = {}, _define_property(_obj5, "BASELINE" /* BASELINE */, "end"), _define_property(_obj5, "CENTER" /* CENTER */, "center"), _define_property(_obj5, "END" /* END */, "end"), _define_property(_obj5, "START" /* START */, "start"), _define_property(_obj5, "STRETCH" /* STRETCH */, "stretch"), _obj5);
var _obj6;
var flexHorizontalConverter = (_obj6 = {}, _define_property(_obj6, "CENTER" /* CENTER */, "center"), _define_property(_obj6, "END" /* END */, "end"), _define_property(_obj6, "START" /* START */, "start"), _obj6);
var _obj7;
var flexDirectionConverter = (_obj7 = {}, _define_property(_obj7, "ROW" /* ROW */, "row"), _define_property(_obj7, "COLUMN" /* COLUMN */, "column"), _obj7);
// src/library/elements/impression.tsx
import React7 from "react";
import { gql as gql5 } from "@apollo/client";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
var __ImpressionFragment = gql5(_templateObject9());
var Impression = function (param) {
  var impression = param.impression,
    children = param.children;
  return /* @__PURE__ */React7.createElement(IntersectionTracker, {
    trackOnce: impression.trackOnce,
    linkName: impression.analytics.linkName,
    referrerId: impression.analytics.referrerId
  }, children || /* @__PURE__ */React7.createElement("span", null));
};
Impression.displayName = "ImpressionWrapper";
Impression.fragment = __ImpressionFragment;
// src/library/elements/text-info/text-info-link.tsx
import React9 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkIcon as UitkIcon2, UitkIconSize as UitkIconSize2 } from "@egds/react-core/icons";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { UitkLink as UitkLink2 } from "uitk-react-link";
import { UitkSpacing } from "uitk-react-spacing";
// src/library/elements/modal/modal-trigger.tsx
import React8 from "react";
import { EGDSImageLink } from "@egds/react-core/images";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { UitkPrimaryButton, UitkSecondaryButton, UitkTertiaryButton as UitkTertiaryButton2 } from "uitk-react-button";
import { UitkLink } from "uitk-react-link";
var ModalTrigger = function (param) {
  var modalId = param.modalId,
    queryKey = param.queryKey,
    buttonText = param.buttonText,
    onClick = param.onClick,
    type = param.type,
    children = param.children,
    isFullWidth = param.isFullWidth;
  var id = modalId.includes("/" /* SLASH */) ? extractField(modalId, "/" /* SLASH */, 0) : modalId;
  var urlParameter = modalId.includes("/" /* SLASH */) ? extractField(modalId, "/" /* SLASH */, 1) : "";
  var _useDialog2 = _sliced_to_array(useDialog2(id, queryKey), 2),
    dialogActions = _useDialog2[1];
  var updateUrl = useUpdateUrl();
  var openDialog = function () {
    dialogActions.openDialog();
    if (urlParameter) {
      updateUrl(urlParameter);
    }
    if (onClick) {
      onClick();
    }
  };
  switch (type) {
    case "PRIMARY" /* PRIMARY */:
      return /* @__PURE__ */React8.createElement(UitkPrimaryButton, {
        type: "button",
        tag: "a",
        key: "button-jumplink-".concat(id),
        onClick: openDialog,
        isFullWidth: isFullWidth
      }, children);
    case "SECONDARY" /* SECONDARY */:
      return /* @__PURE__ */React8.createElement(UitkSecondaryButton, {
        type: "button",
        key: "button-jumplink-".concat(id),
        onClick: openDialog,
        isFullWidth: isFullWidth
      }, children);
    case "TERTIARY" /* TERTIARY */:
      return /* @__PURE__ */React8.createElement(UitkTertiaryButton2, {
        type: "button",
        tag: "a",
        key: "button-jumplink-".concat(id),
        onClick: openDialog,
        isFullWidth: isFullWidth
      }, children);
    case "EGDSImage":
      return /* @__PURE__ */React8.createElement(EGDSImageLink, null, /* @__PURE__ */React8.createElement("button", {
        onClick: openDialog,
        type: "button"
      }, /* @__PURE__ */React8.createElement("span", {
        className: "is-visually-hidden"
      }, buttonText)));
    default:
      return /* @__PURE__ */React8.createElement(UitkLink, {
        onClick: openDialog
      }, /* @__PURE__ */React8.createElement("button", {
        type: "button",
        style: {
          alignItems: "center"
        }
      }, children));
  }
};
// src/library/elements/text-info/text-info-link.tsx
var __TextInfoLink = gql6(_templateObject10(), EGDSIcon.fragment, ExperimentalAnalytics.fragment);
var renderIcon = function (icon) {
  return /* @__PURE__ */React9.createElement(UitkIcon2, {
    name: icon.id,
    size: icon.size ? UitkIconSize2[icon.size] : UitkIconSize2.MEDIUM
  });
};
var sendAnalytics = function (analytics, clickTracker) {
  if (analytics) {
    var client = analytics.client,
      appendToReferrerId = analytics.appendToReferrerId;
    trackClick(clickTracker, "".concat(client.referrerId).concat(appendToReferrerId), client.linkName);
  }
};
var renderLinkContent = function (param) {
  var icon = param.icon,
    iconPosition = param.iconPosition,
    inlineSpace = param.inlineSpace,
    text = param.text;
  return /* @__PURE__ */React9.createElement(React9.Fragment, null, icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React9.createElement(UitkSpacing, {
    margin: {
      inlineend: inlineSpace !== null && inlineSpace !== void 0 ? inlineSpace : "unset"
    }
  }, renderIcon(icon)), text, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React9.createElement(UitkSpacing, {
    margin: {
      inlinestart: inlineSpace !== null && inlineSpace !== void 0 ? inlineSpace : "unset"
    }
  }, renderIcon(icon)));
};
var renderAction = function (action, clickTracker, index) {
  switch (action.type) {
    case "JUMPLINK" /* JUMPLINK */:
      return /* @__PURE__ */React9.createElement(UitkLink2, {
        key: "jumplink-key-".concat(action.type, "-").concat(index),
        onClick: function () {
          return action.analytics && sendAnalytics(action.analytics, clickTracker);
        }
      }, /* @__PURE__ */React9.createElement("a", {
        href: "".concat(action.data.action.url)
      }, renderLinkContent(action.data)));
    case "MODAL" /* MODAL */:
      var _action_data_action_modal;
      return ((_action_data_action_modal = action.data.action.modal) === null || _action_data_action_modal === void 0 ? void 0 : _action_data_action_modal.id) ? /* @__PURE__ */React9.createElement(ModalTrigger, {
        key: "modal-trigger-".concat(action.type, "-").concat(index),
        modalId: action.data.action.modal.id,
        queryKey: action.data.action.modal.queryKey || void 0,
        buttonText: action.data.text,
        onClick: function () {
          return action.analytics && sendAnalytics(action.analytics, clickTracker);
        }
      }, renderLinkContent(action.data)) : null;
    default:
      return /* @__PURE__ */React9.createElement(UitkLink2, {
        key: "redirect-key-".concat(action.type, "-").concat(index),
        onClick: function () {
          return action.analytics && sendAnalytics(action.analytics, clickTracker);
        }
      }, /* @__PURE__ */React9.createElement("a", {
        href: "".concat(action.data.action.url)
      }, renderLinkContent(action.data)));
  }
};
var TextInfoLink = function (param) {
  var config = param.config;
  var infoSection = config.infoSection;
  var container = config.container;
  var clickTracker = useClickTracker3();
  return /* @__PURE__ */React9.createElement(React9.Fragment, null, (infoSection === null || infoSection === void 0 ? void 0 : infoSection.links) && infoSection.links.length > 0 && infoSection.links.map(function (link, index) {
    return renderAction(link, clickTracker, index);
  }), (container === null || container === void 0 ? void 0 : container.action) && container.action.data && renderAction(container.action, clickTracker));
};
TextInfoLink.displayName = "TextInfoLink";
TextInfoLink.fragment = __TextInfoLink;
// src/library/elements/container.tsx
import { ExperienceTemplateRenderer as ExperienceTemplateRenderer3 } from "experience-template-renderer-react";
var __ContainerFragment = gql7(_templateObject11(), TextInfoLink.fragment, Impression.fragment);
var Container = function (param) {
  var templateComponent = param.templateComponent;
  var _config_container, _config_container1, _container_flex, _templateComponent_metadata;
  var children = templateComponent.children;
  var config = templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.config;
  var container = config.container;
  var flex = (_config_container = config.container) === null || _config_container === void 0 ? void 0 : _config_container.flex;
  var impression = (_config_container1 = config.container) === null || _config_container1 === void 0 ? void 0 : _config_container1.impression;
  var isStretch = (container === null || container === void 0 ? void 0 : (_container_flex = container.flex) === null || _container_flex === void 0 ? void 0 : _container_flex.vertical) === "STRETCH" /* STRETCH */;
  var flexLayout = container.flex && children && (children === null || children === void 0 ? void 0 : children.length) > 0 && /* @__PURE__ */React10.createElement(UitkLayoutFlex, {
    "data-view-id": (_templateComponent_metadata = templateComponent.metadata) === null || _templateComponent_metadata === void 0 ? void 0 : _templateComponent_metadata.id,
    space: "two",
    style: isStretch ? {
      height: "100%",
      width: "100%"
    } : {},
    direction: (flex === null || flex === void 0 ? void 0 : flex.direction) ? flexDirectionConverter[flex === null || flex === void 0 ? void 0 : flex.direction] : void 0,
    justifyContent: (flex === null || flex === void 0 ? void 0 : flex.horizontal) ? flexHorizontalConverter[flex === null || flex === void 0 ? void 0 : flex.horizontal] : void 0,
    alignItems: (flex === null || flex === void 0 ? void 0 : flex.vertical) ? flexVerticalConverter[flex === null || flex === void 0 ? void 0 : flex.vertical] : void 0
  }, /* @__PURE__ */React10.createElement(UitkLayoutFlexItem, {
    grow: 1
  }, isStretch ? /* @__PURE__ */React10.createElement("div", {
    style: {
      alignContent: "flex-end"
    }
  }, /* @__PURE__ */React10.createElement(ExperienceTemplateRenderer3, {
    templateComponents: children
  })) : /* @__PURE__ */React10.createElement(ExperienceTemplateRenderer3, {
    templateComponents: children
  })), container.impression && /* @__PURE__ */React10.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React10.createElement(Impression, {
    impression: impression
  }, null)));
  return container ? /* @__PURE__ */React10.createElement(React10.Fragment, null, container.impression && (children === null || children === void 0 ? void 0 : children.length) && !flexLayout && /* @__PURE__ */React10.createElement(Impression, {
    impression: impression
  }, /* @__PURE__ */React10.createElement(ExperienceTemplateRenderer3, {
    templateComponents: children
  })), flexLayout, container.action && /* @__PURE__ */React10.createElement(TextInfoLink, {
    config: config
  })) : null;
};
Container.displayName = "ContainerWrapper";
Container.fragment = __ContainerFragment;
// src/library/elements/expando.tsx
import React11 from "react";
import { gql as gql8 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkExpandoList, UitkExpandoListItem, UitkExpandoPeek } from "uitk-react-expando";
import { UitkText } from "uitk-react-text";
import { ExperienceTemplateRenderer as ExperienceTemplateRenderer4 } from "experience-template-renderer-react";
var __ExpandoFragment = gql8(_templateObject12(), ExperimentalAnalytics.fragment);
var Expando = function (param) {
  var templateComponent = param.templateComponent;
  var children = templateComponent.children;
  var config = templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.config;
  var expando = config.expando;
  var clickTracker = useClickTracker4();
  var _React11_useState = _sliced_to_array(React11.useState(false), 2),
    isVisible = _React11_useState[0],
    setIsVisible = _React11_useState[1];
  var sendAnalytics2 = function () {
    if (expando === null || expando === void 0 ? void 0 : expando.analytics) {
      var _expando_analytics = expando.analytics,
        client = _expando_analytics.client,
        appendToReferrerId = _expando_analytics.appendToReferrerId;
      trackClick(clickTracker, "".concat(client.referrerId).concat(appendToReferrerId), client.linkName);
    }
  };
  if (children === null || children === void 0 ? void 0 : children.length) {
    var _templateComponent_metadata, _templateComponent_metadata1;
    var childrenElements = /* @__PURE__ */React11.createElement(ExperienceTemplateRenderer4, {
      templateComponents: children
    });
    return expando.isList ? /* @__PURE__ */React11.createElement(UitkExpandoList, {
      "data-view-id": (_templateComponent_metadata = templateComponent.metadata) === null || _templateComponent_metadata === void 0 ? void 0 : _templateComponent_metadata.id
    }, /* @__PURE__ */React11.createElement(UitkExpandoListItem, {
      isIndented: false,
      expandoTitle: /* @__PURE__ */React11.createElement(UitkText, null, expando.expandLabel),
      expandoDescription: childrenElements,
      onToggle: function () {
        setIsVisible(!isVisible);
        sendAnalytics2();
      },
      key: "expando-list-item"
    })) : /* @__PURE__ */React11.createElement(UitkExpandoPeek, {
      "data-view-id": (_templateComponent_metadata1 = templateComponent.metadata) === null || _templateComponent_metadata1 === void 0 ? void 0 : _templateComponent_metadata1.id,
      isVisible: isVisible,
      handleClick: function () {
        setIsVisible(function (show) {
          return !show;
        });
        sendAnalytics2();
      },
      lines: expando.linesToShow || 3,
      items: expando.itemsToShow || 3,
      hideScrim: true,
      whitespace: false,
      expandLabel: expando.expandLabel,
      collapseLabel: expando.collapseLabel || expando.expandLabel
    }, childrenElements);
  }
  return null;
};
Expando.displayName = "ExpandoWrapper";
Expando.fragment = __ExpandoFragment;
// src/library/elements/intersection.tsx
import React12 from "react";
import { gql as gql9 } from "@apollo/client";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { ExperienceTemplateRenderer as ExperienceTemplateRenderer5 } from "experience-template-renderer-react";
var __IntersectionFragment = gql9(_templateObject13());
var Intersection = function (param) {
  var templateComponent = param.templateComponent;
  var children = templateComponent.children;
  var config = templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.config;
  var intersection = config.intersection;
  var getMicroMessages = function (uisPrimeMessages) {
    return uisPrimeMessages === null || uisPrimeMessages === void 0 ? void 0 : uisPrimeMessages.map(function (uisPrimeMessage) {
      return {
        messageContent: JSON.parse(uisPrimeMessage.messageContent),
        schemaName: uisPrimeMessage.schemaName
      };
    });
  };
  return (children === null || children === void 0 ? void 0 : children.length) ? /* @__PURE__ */React12.createElement(IntersectionTracker2, {
    trackOnce: intersection.trackOnce,
    linkName: intersection.analytics.linkName,
    referrerId: intersection.analytics.referrerId,
    additionalUisPrimeMicroMessages: getMicroMessages(intersection.analytics.uisPrimeMessages)
  }, /* @__PURE__ */React12.createElement(ExperienceTemplateRenderer5, {
    templateComponents: children
  })) : null;
};
Intersection.displayName = "IntersectionWrapper";
Intersection.fragment = __IntersectionFragment;
// src/library/elements/layout-grid.tsx
import React13 from "react";
import { gql as gql10 } from "@apollo/client";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { ExperienceTemplateRenderer as ExperienceTemplateRenderer6 } from "experience-template-renderer-react";
var __LayoutGridFragment = gql10(_templateObject14());
var LayoutGrid = function (param) {
  var templateComponent = param.templateComponent;
  var _templateComponent_metadata, _grid_gridItem;
  var children = templateComponent.children;
  var config = templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.config;
  var grid = config.grid;
  var _grid_space;
  return grid ? /* @__PURE__ */React13.createElement(UitkLayoutGrid, {
    "data-view-id": (_templateComponent_metadata = templateComponent.metadata) === null || _templateComponent_metadata === void 0 ? void 0 : _templateComponent_metadata.id,
    columns: grid === null || grid === void 0 ? void 0 : grid.columns,
    space: (_grid_space = grid === null || grid === void 0 ? void 0 : grid.space) !== null && _grid_space !== void 0 ? _grid_space : void 0
  }, (_grid_gridItem = grid.gridItem) === null || _grid_gridItem === void 0 ? void 0 : _grid_gridItem.map(function (column, index) {
    var child = children === null || children === void 0 ? void 0 : children[index];
    if (child != null) {
      return /* @__PURE__ */React13.createElement(UitkLayoutGridItem, {
        colSpan: column.colSpan,
        rowSpan: column.colSpan,
        key: "layout-grid-item-".concat(index)
      }, /* @__PURE__ */React13.createElement("div", null, /* @__PURE__ */React13.createElement(ExperienceTemplateRenderer6, {
        templateComponents: [child]
      })));
    }
    return null;
  })) : null;
};
LayoutGrid.displayName = "LayoutGrid";
LayoutGrid.fragment = __LayoutGridFragment;
// src/library/elements/media/index.tsx
import React15 from "react";
import { gql as gql12 } from "@apollo/client";
// src/library/elements/media/image.tsx
import React14 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSFigure, EGDSImage } from "@egds/react-core/images";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
var __ImageWrapper = gql11(_templateObject15(), ExperimentalLinkAction.fragment, ExperimentalAnalytics.fragment);
var ImageWrapper = function (param) {
  var config = param.config;
  var _image_actions;
  var media = config.media;
  var clickTracker = useClickTracker5();
  if (!(media === null || media === void 0 ? void 0 : media.image)) {
    return null;
  }
  var image = media.image;
  var handleClick = function () {
    if (image === null || image === void 0 ? void 0 : image.events) {
      var _image_events;
      return (_image_events = image.events) === null || _image_events === void 0 ? void 0 : _image_events.map(function (event) {
        var _event_client = event.client,
          referrerId = _event_client.referrerId,
          linkName = _event_client.linkName;
        trackClick(clickTracker, referrerId, linkName);
      });
    }
  };
  return /* @__PURE__ */React14.createElement(EGDSFigure, {
    imageFit: ImageFitMap[image.imageFit],
    ratio: AspectRatioMap[image.aspectRatio],
    roundcorner: RoundedCornerMap[image.roundedCorner]
  }, /* @__PURE__ */React14.createElement(EGDSImage, {
    alt: image.description || "",
    lazyLoading: LazyloadingMap[image.lazyLoading],
    blankDefault: image.useBlank,
    placeholderImage: image.placeholder,
    src: image.source
  }), image === null || image === void 0 ? void 0 : (_image_actions = image.actions) === null || _image_actions === void 0 ? void 0 : _image_actions.map(function (action, index) {
    var _action_data_action_modal;
    return action.type === "MODAL" /* MODAL */ && ((_action_data_action_modal = action.data.action.modal) === null || _action_data_action_modal === void 0 ? void 0 : _action_data_action_modal.id) ? /* @__PURE__ */React14.createElement(ModalTrigger, {
      key: "modal-trigger-image-".concat(action.type, "-").concat(index),
      type: "EGDSImage",
      modalId: action.data.action.modal.id,
      queryKey: action.data.action.modal.queryKey || void 0,
      buttonText: image.description || "",
      onClick: handleClick
    }) : null;
  }));
};
ImageWrapper.displayName = "ImageWrapper";
ImageWrapper.fragment = __ImageWrapper;
// src/library/elements/media/index.tsx
var __Media = gql12(_templateObject16(), ImageWrapper.fragment);
var Media = function (param) {
  var templateComponent = param.templateComponent;
  var _templateComponent_metadata;
  var config = templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.config;
  if (!config.media) {
    return null;
  }
  var image = config.media.image;
  return /* @__PURE__ */React15.createElement(React15.Fragment, null, image && /* @__PURE__ */React15.createElement(ImageWrapper, {
    "data-view-id": (_templateComponent_metadata = templateComponent.metadata) === null || _templateComponent_metadata === void 0 ? void 0 : _templateComponent_metadata.id,
    config: config
  }));
};
Media.displayName = "Media";
Media.fragment = __Media;
// src/library/elements/modal/index.tsx
import React21 from "react";
import { gql as gql13 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
// src/library/elements/modal/bottom-sheet.tsx
import React16 from "react";
import { UitkSheet, UitkSheetContent, UitkSheetTransition } from "uitk-react-sheet";
import { UitkToolbar } from "uitk-react-toolbar";
var _obj8;
// src/library/mapper/modal-nav-mapper.ts
var NavTypeMap = (_obj8 = {}, _define_property(_obj8, "BACK" /* BACK */, "back"), _define_property(_obj8, "CLOSE" /* CLOSE */, "close"), _define_property(_obj8, "EXPAND_DOWN" /* EXPAND_DOWN */, "expand_down"), _define_property(_obj8, "EXPAND_UP" /* EXPAND_UP */, "expand_up"), _obj8);
var _obj9;
var SideSheetColumnMap = (_obj9 = {}, _define_property(_obj9, "ONE" /* ONE */, 1), _define_property(_obj9, "THREE" /* THREE */, 3), _define_property(_obj9, "TWO" /* TWO */, 2), _define_property(_obj9, "FOUR" /* FOUR */, 4), _define_property(_obj9, "SIX" /* SIX */, 6), _define_property(_obj9, "EIGHT" /* EIGHT */, 8), _define_property(_obj9, "TWELVE" /* TWELVE */, 12), _obj9);
// src/library/elements/modal/bottom-sheet.tsx
var BottomSheet = function (param) {
  var isDialogOpen = param.isDialogOpen,
    closeCallback = param.closeCallback,
    onCloseClick = param.onCloseClick,
    ref = param.ref,
    modal = param.modal,
    children = param.children;
  return /* @__PURE__ */React16.createElement(UitkSheetTransition, {
    isVisible: isDialogOpen,
    closeCallback: closeCallback
  }, /* @__PURE__ */React16.createElement(UitkSheet, {
    fullWidth: modal.fullWidth,
    isExpanded: modal.isExpanded,
    type: "bottom",
    isVisible: isDialogOpen,
    triggerRef: ref
  }, /* @__PURE__ */React16.createElement(React16.Fragment, null, modal.toolbar && /* @__PURE__ */React16.createElement(UitkToolbar, {
    navigationContent: {
      onClick: onCloseClick,
      navType: NavTypeMap[modal.toolbar.navType],
      navIconLabel: modal.toolbar.closeLabel,
      navButtonId: "bottom-toolbar-close-button"
    },
    toolbarTitle: modal.toolbar.title
  }), /* @__PURE__ */React16.createElement(UitkSheetContent, null, children))));
};
// src/library/elements/modal/centered-sheet.tsx
import React17 from "react";
import { UitkSheet as UitkSheet2, UitkSheetContent as UitkSheetContent2, UitkSheetTransition as UitkSheetTransition2 } from "uitk-react-sheet";
import { UitkToolbar as UitkToolbar2 } from "uitk-react-toolbar";
var CenteredSheet = function (param) {
  var isDialogOpen = param.isDialogOpen,
    closeCallback = param.closeCallback,
    onCloseClick = param.onCloseClick,
    ref = param.ref,
    modal = param.modal,
    children = param.children,
    DialogComponent = param.DialogComponent;
  return /* @__PURE__ */React17.createElement(UitkSheetTransition2, {
    isVisible: isDialogOpen,
    closeCallback: closeCallback
  }, /* @__PURE__ */React17.createElement(DialogComponent, null, /* @__PURE__ */React17.createElement(UitkSheet2, {
    type: "centered",
    isVisible: isDialogOpen,
    triggerRef: ref
  }, /* @__PURE__ */React17.createElement(React17.Fragment, null, modal.toolbar && /* @__PURE__ */React17.createElement(UitkToolbar2, {
    navigationContent: {
      onClick: onCloseClick,
      navType: NavTypeMap[modal.toolbar.navType],
      navIconLabel: modal.toolbar.closeLabel,
      navButtonId: "centered-toolbar-close-button"
    },
    toolbarTitle: modal.toolbar.title
  }), /* @__PURE__ */React17.createElement(UitkSheetContent2, null, children)))));
};
// src/library/elements/modal/full-sheet.tsx
import React18 from "react";
import { UitkSheet as UitkSheet3, UitkSheetContent as UitkSheetContent3, UitkSheetTransition as UitkSheetTransition3 } from "uitk-react-sheet";
import { UitkToolbar as UitkToolbar3 } from "uitk-react-toolbar";
var FullSheet = function (param) {
  var isDialogOpen = param.isDialogOpen,
    closeCallback = param.closeCallback,
    onCloseClick = param.onCloseClick,
    ref = param.ref,
    modal = param.modal,
    children = param.children,
    DialogComponent = param.DialogComponent;
  return /* @__PURE__ */React18.createElement(UitkSheetTransition3, {
    isVisible: isDialogOpen,
    closeCallback: closeCallback
  }, /* @__PURE__ */React18.createElement(DialogComponent, null, /* @__PURE__ */React18.createElement(UitkSheet3, {
    type: "full",
    isVisible: isDialogOpen,
    triggerRef: ref
  }, /* @__PURE__ */React18.createElement(React18.Fragment, null, modal.toolbar && /* @__PURE__ */React18.createElement(UitkToolbar3, {
    navigationContent: {
      onClick: onCloseClick,
      navType: NavTypeMap[modal.toolbar.navType],
      navIconLabel: modal.toolbar.closeLabel,
      navButtonId: "full-toolbar-close-button"
    },
    toolbarTitle: modal.toolbar.title
  }), /* @__PURE__ */React18.createElement(UitkSheetContent3, null, children)))));
};
// src/library/elements/modal/popover-sheet.tsx
import React19 from "react";
import { UitkSheet as UitkSheet4, UitkSheetContent as UitkSheetContent4, UitkSheetTransition as UitkSheetTransition4 } from "uitk-react-sheet";
import { UitkToolbar as UitkToolbar4 } from "uitk-react-toolbar";
var PopoverSheet = function (param) {
  var isDialogOpen = param.isDialogOpen,
    closeCallback = param.closeCallback,
    onCloseClick = param.onCloseClick,
    ref = param.ref,
    modal = param.modal,
    children = param.children;
  return /* @__PURE__ */React19.createElement(UitkSheetTransition4, {
    isVisible: isDialogOpen,
    closeCallback: closeCallback
  }, /* @__PURE__ */React19.createElement(UitkSheet4, {
    type: "popover",
    isVisible: isDialogOpen,
    triggerRef: ref,
    position: {
      inline: "leading",
      block: "trailing"
    }
  }, /* @__PURE__ */React19.createElement(React19.Fragment, null, modal.toolbar && /* @__PURE__ */React19.createElement(UitkToolbar4, {
    navigationContent: {
      onClick: onCloseClick,
      navType: NavTypeMap[modal.toolbar.navType],
      navIconLabel: modal.toolbar.closeLabel,
      navButtonId: "popover-toolbar-close-button"
    },
    toolbarTitle: modal.toolbar.title
  }), /* @__PURE__ */React19.createElement(UitkSheetContent4, null, children))));
};
// src/library/elements/modal/side-sheet.tsx
import React20 from "react";
import { UitkSheet as UitkSheet5, UitkSheetContent as UitkSheetContent5, UitkSheetTransition as UitkSheetTransition5 } from "uitk-react-sheet";
import { UitkToolbar as UitkToolbar5 } from "uitk-react-toolbar";
var SideSheet = function (param) {
  var isDialogOpen = param.isDialogOpen,
    closeCallback = param.closeCallback,
    onCloseClick = param.onCloseClick,
    ref = param.ref,
    modal = param.modal,
    children = param.children;
  return /* @__PURE__ */React20.createElement(UitkSheetTransition5, {
    isVisible: isDialogOpen,
    closeCallback: closeCallback
  }, /* @__PURE__ */React20.createElement(UitkSheet5, {
    overflow: true,
    type: "side",
    sideSheetLayout: {
      columns: SideSheetColumnMap[modal.sideSheetLayout],
      position: "trailing"
    },
    isVisible: isDialogOpen,
    triggerRef: ref
  }, /* @__PURE__ */React20.createElement(React20.Fragment, null, modal.toolbar && /* @__PURE__ */React20.createElement(UitkToolbar5, {
    navigationContent: {
      onClick: onCloseClick,
      navType: NavTypeMap[modal.toolbar.navType],
      navIconLabel: modal.toolbar.closeLabel,
      navButtonId: "toolbar-close-button"
    },
    toolbarTitle: modal.toolbar.title
  }), /* @__PURE__ */React20.createElement(UitkSheetContent5, null, children))));
};
// src/library/elements/modal/index.tsx
import { ExperienceTemplateRenderer as ExperienceTemplateRenderer7 } from "experience-template-renderer-react";
var __ModalConfigFragment = gql13(_templateObject17(), ExperimentalAnalytics.fragment);
var Modal = function (param) {
  var templateComponent = param.templateComponent;
  var children = templateComponent.children;
  var config = templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.config;
  var modal = config.modal;
  var clickTracker = useClickTracker6();
  var _useDialog3 = _sliced_to_array(useDialog3(modal.modalId.id, modal.modalId.queryKey || void 0), 3),
    isDialogOpen = _useDialog3[0],
    dialogActions = _useDialog3[1],
    DialogComponent = _useDialog3[2];
  var modalRef = React21.createRef();
  if (!(children === null || children === void 0 ? void 0 : children.length)) {
    return null;
  }
  var closeCallback = function () {
    var _modal_toolbar;
    if ((_modal_toolbar = modal.toolbar) === null || _modal_toolbar === void 0 ? void 0 : _modal_toolbar.analytics) {
      var _modal_toolbar_analytics = modal.toolbar.analytics,
        client = _modal_toolbar_analytics.client,
        appendToReferrerId = _modal_toolbar_analytics.appendToReferrerId;
      trackClick(clickTracker, "".concat(client.referrerId).concat(appendToReferrerId), client.linkName);
    }
  };
  var onCloseClick = function () {
    dialogActions.closeDialog();
  };
  switch (modal.type) {
    case "SIDE" /* SIDE */:
      return /* @__PURE__ */React21.createElement(SideSheet, {
        isDialogOpen: isDialogOpen,
        closeCallback: closeCallback,
        onCloseClick: onCloseClick,
        ref: modalRef,
        modal: modal
      }, /* @__PURE__ */React21.createElement(ExperienceTemplateRenderer7, {
        templateComponents: children
      }));
    case "CENTERED" /* CENTERED */:
      return /* @__PURE__ */React21.createElement(CenteredSheet, {
        isDialogOpen: isDialogOpen,
        DialogComponent: DialogComponent,
        closeCallback: closeCallback,
        onCloseClick: onCloseClick,
        ref: modalRef,
        modal: modal
      }, /* @__PURE__ */React21.createElement(ExperienceTemplateRenderer7, {
        templateComponents: children
      }));
    case "FULL" /* FULL */:
      return /* @__PURE__ */React21.createElement(FullSheet, {
        isDialogOpen: isDialogOpen,
        DialogComponent: DialogComponent,
        closeCallback: closeCallback,
        onCloseClick: onCloseClick,
        ref: modalRef,
        modal: modal
      }, /* @__PURE__ */React21.createElement(ExperienceTemplateRenderer7, {
        templateComponents: children
      }));
    case "POPOVER" /* POPOVER */:
      return /* @__PURE__ */React21.createElement(PopoverSheet, {
        isDialogOpen: isDialogOpen,
        closeCallback: closeCallback,
        onCloseClick: onCloseClick,
        ref: modalRef,
        modal: modal
      }, /* @__PURE__ */React21.createElement(ExperienceTemplateRenderer7, {
        templateComponents: children
      }));
    default:
      return /* @__PURE__ */React21.createElement(BottomSheet, {
        isDialogOpen: isDialogOpen,
        closeCallback: closeCallback,
        onCloseClick: onCloseClick,
        ref: modalRef,
        modal: modal
      }, /* @__PURE__ */React21.createElement(ExperienceTemplateRenderer7, {
        templateComponents: children
      }));
  }
};
Modal.displayName = "ExperimentalModal";
Modal.fragment = __ModalConfigFragment;
// src/library/elements/rating.tsx
import React22 from "react";
import { gql as gql14 } from "@apollo/client";
import { UitkRating } from "uitk-react-rating";
var __RatingFragment = gql14(_templateObject18());
var Rating = function (param) {
  var templateComponent = param.templateComponent;
  var _templateComponent_metadata;
  var config = templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.config;
  var rating = config.rating;
  var _rating_accessibility;
  return /* @__PURE__ */React22.createElement(UitkRating, {
    "data-view-id": (_templateComponent_metadata = templateComponent.metadata) === null || _templateComponent_metadata === void 0 ? void 0 : _templateComponent_metadata.id,
    icon: (rating === null || rating === void 0 ? void 0 : rating.iconId) === "STAR" ? "star" : "alternate",
    rating: String(rating === null || rating === void 0 ? void 0 : rating.rating),
    a11yText: (_rating_accessibility = rating === null || rating === void 0 ? void 0 : rating.accessibility) !== null && _rating_accessibility !== void 0 ? _rating_accessibility : void 0
  });
};
Rating.displayName = "RatingWrapper";
Rating.fragment = __RatingFragment;
// src/library/elements/script.tsx
import React23 from "react";
import { gql as gql15 } from "@apollo/client";
import { ExperienceTemplateRenderer as ExperienceTemplateRenderer8 } from "experience-template-renderer-react";
var __ScriptFragment = gql15(_templateObject19(), ExperimentalScript.fragment);
var Script = function (param) {
  var templateComponent = param.templateComponent;
  var children = templateComponent.children;
  return (children === null || children === void 0 ? void 0 : children.length) ? /* @__PURE__ */React23.createElement(ExperienceTemplateRenderer8, {
    templateComponents: children
  }) : null;
};
Script.displayName = "ScriptWrapper";
Script.fragment = __ScriptFragment;
// src/library/elements/spacing.tsx
import React24 from "react";
import { gql as gql16 } from "@apollo/client";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
var _obj10;
// src/library/mapper/uitk-mappers.ts
var SpacingMap = (_obj10 = {}, _define_property(_obj10, "HALF" /* HALF */, "half"), _define_property(_obj10, "ONE" /* ONE */, "one"), _define_property(_obj10, "TWO" /* TWO */, "two"), _define_property(_obj10, "THREE" /* THREE */, "three"), _define_property(_obj10, "FOUR" /* FOUR */, "four"), _define_property(_obj10, "SIX" /* SIX */, "six"), _define_property(_obj10, "TWELVE" /* TWELVE */, "twelve"), _define_property(_obj10, "SIXTEEN" /* SIXTEEN */, "sixteen"), _define_property(_obj10, "UNSET" /* UNSET */, "unset"), _obj10);
// src/library/elements/spacing.tsx
import { ExperienceTemplateRenderer as ExperienceTemplateRenderer9 } from "experience-template-renderer-react";
var __SpacingFragment = gql16(_templateObject20());
var Spacing = function (param) {
  var templateComponent = param.templateComponent;
  var _templateComponent_metadata;
  var children = templateComponent.children;
  var config = templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.config;
  var spacing = config.spacing;
  var _ref = spacing || {},
    margin = _ref.margin,
    padding = _ref.padding,
    marginSpace = _ref.marginSpace,
    paddingSpace = _ref.paddingSpace,
    inlineMarginSpace = _ref.inlineMarginSpace,
    inlinePaddingSpace = _ref.inlinePaddingSpace;
  var calcMargin = margin || (marginSpace ? SpacingMap[marginSpace] : void 0);
  var calcPadding = padding || (paddingSpace ? SpacingMap[paddingSpace] : void 0);
  return /* @__PURE__ */React24.createElement(UitkSpacing2, {
    margin: {
      block: calcMargin,
      inline: inlineMarginSpace ? SpacingMap[inlineMarginSpace] : "unset"
    },
    padding: {
      block: calcPadding,
      inline: inlinePaddingSpace ? SpacingMap[inlinePaddingSpace] : "unset"
    }
  }, /* @__PURE__ */React24.createElement("div", {
    "data-view-id": (_templateComponent_metadata = templateComponent.metadata) === null || _templateComponent_metadata === void 0 ? void 0 : _templateComponent_metadata.id
  }, (children === null || children === void 0 ? void 0 : children.length) ? /* @__PURE__ */React24.createElement(ExperienceTemplateRenderer9, {
    templateComponents: children
  }) : null));
};
Spacing.displayName = "SpacingWrapper";
Spacing.fragment = __SpacingFragment;
// src/library/elements/tabs.tsx
import React25 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkNavigationType, UitkTab, UitkTabs, UitkTabsType } from "@egds/react-core/tabs";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { UitkCardContentSection as UitkCardContentSection2 } from "uitk-react-cards";
import { UitkSticky } from "uitk-react-sticky";
import { ExperienceTemplateRenderer as ExperienceTemplateRenderer10 } from "experience-template-renderer-react";
var __TabsConfigFragment = gql17(_templateObject21(), ExperimentalTab.fragment);
var Tabs = function (param) {
  var templateComponent = param.templateComponent;
  var _templateComponent_metadata;
  var children = templateComponent.children;
  var config = templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.config;
  var tabContainer = config.tabs;
  var clickTracker = useClickTracker7();
  var _React25_useState = _sliced_to_array(React25.useState(tabContainer.selectedIndex), 2),
    selectedTab = _React25_useState[0],
    setSelectedTab = _React25_useState[1];
  var _React25_useState1 = _sliced_to_array(React25.useState(tabContainer.tabs.map(function () {
      return React25.createRef();
    })), 1),
    tabRefs = _React25_useState1[0];
  if (tabContainer.tabs.length === 0 || !children) {
    return null;
  }
  var onTabClick = function (selectedIndex) {
    setSelectedTab(selectedIndex);
    var selected = tabContainer.tabs[selectedIndex];
    if (selected === null || selected === void 0 ? void 0 : selected.analytics) {
      var analytics = selected.analytics;
      if (analytics) {
        trackClick(clickTracker, "".concat(analytics.client.referrerId).concat(analytics.appendToReferrerId), analytics.client.linkName);
      }
    }
  };
  if (tabContainer.isJumpLink) {
    var _templateComponent_metadata1;
    return /* @__PURE__ */React25.createElement(React25.Fragment, null, /* @__PURE__ */React25.createElement(UitkSticky, {
      zIndex: 900,
      "data-view-id": (_templateComponent_metadata1 = templateComponent.metadata) === null || _templateComponent_metadata1 === void 0 ? void 0 : _templateComponent_metadata1.id
    }, /* @__PURE__ */React25.createElement(UitkTabs, {
      selectedTab: selectedTab,
      onTabSelect: function (selectedIndex) {
        return onTabClick(selectedIndex);
      },
      navigationType: UitkNavigationType.JUMPLINK,
      tabsType: UitkTabsType.NATURAL,
      scrollOffsetSelf: true
    }, tabContainer.tabs.map(function (tab, index) {
      return /* @__PURE__ */React25.createElement(UitkTab, {
        id: tab.target,
        key: "uitk-tab-key-".concat(tab.target),
        name: tab.title,
        targetRef: tabRefs[index],
        targetURI: "?jumpTargetTab=#".concat(tab.target)
      });
    }))), tabContainer.tabs.map(function (tab, index) {
      var child = children[index];
      return child && /* @__PURE__ */React25.createElement(UitkCardContentSection2, {
        key: "experimental-tab-".concat(index)
      }, /* @__PURE__ */React25.createElement("div", {
        id: tab.target,
        ref: tabRefs[index]
      }, /* @__PURE__ */React25.createElement(ExperienceTemplateRenderer10, {
        templateComponents: [child]
      })));
    }));
  }
  return /* @__PURE__ */React25.createElement(UitkTabs, {
    "data-view-id": (_templateComponent_metadata = templateComponent.metadata) === null || _templateComponent_metadata === void 0 ? void 0 : _templateComponent_metadata.id,
    selectedTab: selectedTab,
    onTabSelect: function (selectedIndex) {
      return onTabClick(selectedIndex);
    },
    navigationType: UitkNavigationType.DEFAULT
  }, tabContainer.tabs.map(function (tab, index) {
    var child = children[index];
    return child && /* @__PURE__ */React25.createElement(UitkTab, {
      key: "experimental-tab-".concat(index),
      name: tab.title,
      targetURI: "?equalTargetTab=#".concat(tab.target),
      id: tab.target,
      tabLinkAttr: {
        id: "tab-".concat(index)
      }
    }, /* @__PURE__ */React25.createElement(ExperienceTemplateRenderer10, {
      templateComponents: [child]
    }));
  }));
};
Tabs.displayName = "ExperimentalTabs";
Tabs.fragment = __TabsConfigFragment;
// src/library/elements/text-info/index.tsx
import React27 from "react";
import { gql as gql19 } from "@apollo/client";
import { UitkIcon as UitkIcon4 } from "@egds/react-core/icons";
import { UitkBadgeStandard, UitkBadgeStandardThemes as UitkBadgeStandardThemes2 } from "uitk-react-badge";
import { UitkList, UitkListItem } from "uitk-react-list";
import { UitkSpacing as UitkSpacing4 } from "uitk-react-spacing";
import { UitkHeading, UitkParagraph, UitkText as UitkText2 } from "uitk-react-text";
// src/library/elements/text-info/text-style-mapper.ts
import { UitkIconSize as UitkIconSize3 } from "@egds/react-core/icons";
import { UitkBadgeStandardThemes } from "uitk-react-badge";
var _obj11;
var UitkThemeMap = (_obj11 = {}, _define_property(_obj11, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj11, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj11, "PRIMARY" /* PRIMARY */, "emphasis"), _define_property(_obj11, "SECONDARY" /* SECONDARY */, "default"), _define_property(_obj11, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj11, "INVERSE" /* INVERSE */, "inverse"), _define_property(_obj11, "EMPHASIS" /* EMPHASIS */, "emphasis"), _obj11);
var _obj12;
var UitkWeightMap = (_obj12 = {}, _define_property(_obj12, "BOLD" /* BOLD */, "bold"), _define_property(_obj12, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj12, "REGULAR" /* REGULAR */, "regular"), _obj12);
var UitkTypeMarginMap = {
  half: "half",
  one: "one",
  two: "two",
  three: "three",
  four: "four",
  six: "six",
  twelve: "six"
};
var UitkSizeMap = {
  "8": 8,
  "2": 2,
  "3": 3,
  "1": 1,
  "4": 4,
  "5": 5,
  "6": 6,
  "7": 7
};
var UitkTextSizeMap = {
  "100": 100,
  "200": 200,
  "300": 300,
  "400": 400,
  "500": 500,
  "600": 600,
  "700": 700,
  "800": 800,
  "900": 900
};
var UitkStandardBadgeThemeMap = {
  STANDARD: UitkBadgeStandardThemes.STANDARD,
  EMPHASIS: UitkBadgeStandardThemes.EMPHASIS,
  INFO: UitkBadgeStandardThemes.INFO,
  FEATURED: UitkBadgeStandardThemes.FEATURED,
  BRAND: UitkBadgeStandardThemes.BRAND,
  WARNING: UitkBadgeStandardThemes.WARNING,
  POSITIVE: UitkBadgeStandardThemes.POSITIVE
};
var _obj13;
var UitkTextOverflowMap = (_obj13 = {}, _define_property(_obj13, "TRUNCATE" /* TRUNCATE */, "truncate"), _define_property(_obj13, "TRUNCATE_FOUR_LINES" /* TRUNCATE_FOUR_LINES */, "truncate-4-lines"), _define_property(_obj13, "TRUNCATE_THREE_LINES" /* TRUNCATE_THREE_LINES */, "truncate-3-lines"), _define_property(_obj13, "TRUNCATE_TWO_LINES" /* TRUNCATE_TWO_LINES */, "truncate-2-lines"), _define_property(_obj13, "WRAP" /* WRAP */, "wrap"), _obj13);
var _obj14;
var IconSizeMap = (_obj14 = {}, _define_property(_obj14, "EXTRA_SMALL" /* EXTRA_SMALL */, UitkIconSize3.EXTRA_SMALL), _define_property(_obj14, "SMALL" /* SMALL */, UitkIconSize3.SMALL), _define_property(_obj14, "MEDIUM" /* MEDIUM */, UitkIconSize3.MEDIUM), _define_property(_obj14, "LARGE" /* LARGE */, UitkIconSize3.LARGE), _define_property(_obj14, "XLARGE" /* XLARGE */, UitkIconSize3.XLARGE), _define_property(_obj14, "MEDIUM_LARGE" /* MEDIUM_LARGE */, UitkIconSize3.MEDIUM), _obj14);
var UitkParagraphSizeMap = {
  1: 1,
  2: 2,
  3: 3
};
// src/library/elements/text-info/buttons.tsx
import React26 from "react";
import { gql as gql18 } from "@apollo/client";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { UitkPrimaryButton as UitkPrimaryButton2, UitkSecondaryButton as UitkSecondaryButton2, UitkTertiaryButton as UitkTertiaryButton3 } from "uitk-react-button";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
var __Buttons = gql18(_templateObject22(), TextInfoLink.fragment);
var ExperimentalButton = function (param) {
  var type = param.type,
    link = param.link,
    onClick = param.onClick,
    children = param.children,
    isFullWidth = param.isFullWidth;
  switch (type) {
    case "PRIMARY" /* PRIMARY */:
      return /* @__PURE__ */React26.createElement(UitkPrimaryButton2, {
        role: "button",
        type: "button",
        tag: "a",
        key: "button-".concat(link),
        href: "".concat(link),
        onClick: onClick,
        isFullWidth: isFullWidth
      }, children);
    case "SECONDARY" /* SECONDARY */:
      return /* @__PURE__ */React26.createElement(UitkSecondaryButton2, {
        role: "button",
        type: "button",
        tag: "a",
        key: "button-".concat(link),
        href: "".concat(link),
        onClick: onClick,
        isFullWidth: isFullWidth
      }, children);
    case "TERTIARY" /* TERTIARY */:
      return /* @__PURE__ */React26.createElement(UitkTertiaryButton3, {
        role: "button",
        type: "button",
        tag: "a",
        key: "button-".concat(link),
        href: "".concat(link),
        onClick: onClick,
        isFullWidth: isFullWidth
      }, children);
    default:
      return null;
  }
};
var ExperimentalButtons = function (param) {
  var config = param.config;
  var _infoSection_buttons;
  var infoSection = config.infoSection;
  var clickTracker = useClickTracker8();
  var sendAnalytics2 = function (analytics) {
    if (analytics) {
      var client = analytics.client,
        appendToReferrerId = analytics.appendToReferrerId;
      trackClick(clickTracker, "".concat(client.referrerId).concat(appendToReferrerId), client.linkName);
    }
  };
  var renderIcon2 = function (icon) {
    return /* @__PURE__ */React26.createElement(UitkIcon3, {
      name: icon.id
    });
  };
  var renderButtonText = function (param) {
    var icon = param.icon,
      iconPosition = param.iconPosition,
      inlineSpace = param.inlineSpace,
      text = param.text;
    return /* @__PURE__ */React26.createElement(React26.Fragment, null, icon && iconPosition === "LEADING" /* LEADING */ && /* @__PURE__ */React26.createElement(UitkSpacing3, {
      margin: {
        inlineend: inlineSpace !== null && inlineSpace !== void 0 ? inlineSpace : "unset"
      }
    }, renderIcon2(icon)), text, icon && iconPosition === "TRAILING" /* TRAILING */ && /* @__PURE__ */React26.createElement(UitkSpacing3, {
      margin: {
        inlinestart: inlineSpace !== null && inlineSpace !== void 0 ? inlineSpace : "unset"
      }
    }, renderIcon2(icon)));
  };
  return /* @__PURE__ */React26.createElement(React26.Fragment, null, (infoSection === null || infoSection === void 0 ? void 0 : infoSection.buttons) && infoSection.buttons.length > 0 && ((_infoSection_buttons = infoSection.buttons) === null || _infoSection_buttons === void 0 ? void 0 : _infoSection_buttons.map(function (button, index) {
    var type = button.type,
      _button_action = button.action,
      actionType = _button_action.type,
      data = _button_action.data,
      analytics = _button_action.analytics,
      isFullWidth = button.isFullWidth;
    switch (actionType) {
      case "JUMPLINK" /* JUMPLINK */:
        return data.action.url && /* @__PURE__ */React26.createElement(ExperimentalButton, {
          key: "button-jumplink-".concat(type, "-").concat(index),
          type: type,
          link: "#".concat(data.action.url),
          isFullWidth: isFullWidth,
          onClick: function () {
            return analytics && sendAnalytics2(analytics);
          }
        }, renderButtonText(data));
      case "REDIRECT" /* REDIRECT */:
        return data.action.url && /* @__PURE__ */React26.createElement(ExperimentalButton, {
          key: "button-redirect-".concat(type, "-").concat(index),
          type: type,
          link: data.action.url,
          isFullWidth: isFullWidth,
          onClick: function () {
            return analytics && sendAnalytics2(analytics);
          }
        }, renderButtonText(data));
      case "MODAL" /* MODAL */:
        var _data_action_modal;
        return ((_data_action_modal = data.action.modal) === null || _data_action_modal === void 0 ? void 0 : _data_action_modal.id) ? /* @__PURE__ */React26.createElement(ModalTrigger, {
          type: type,
          key: "button-modal-".concat(type, "-").concat(index),
          modalId: data.action.modal.id,
          queryKey: data.action.modal.queryKey || void 0,
          buttonText: data.text,
          isFullWidth: isFullWidth,
          onClick: function () {
            return analytics && sendAnalytics2(analytics);
          }
        }, renderButtonText(data)) : null;
      default:
        return null;
    }
  })));
};
ExperimentalButtons.displayName = "Buttons";
ExperimentalButtons.fragment = __Buttons;
// src/library/elements/text-info/index.tsx
var __TextInfoSection = gql19(_templateObject23(), TextInfoLink.fragment, ExperimentalSpacing.fragment, EGDSIcon.fragment);
var withSpacing = function (spacing, child) {
  return (spacing === null || spacing === void 0 ? void 0 : spacing.margin) ? /* @__PURE__ */React27.createElement(UitkSpacing4, {
    margin: {
      blockend: spacing.margin
    }
  }, /* @__PURE__ */React27.createElement("div", null, child)) : child;
};
var TextInfoSection = function (param) {
  var templateComponent = param.templateComponent;
  var _templateComponent_metadata, _title_attributes, _title_text, _title_attributes1, _title_text1, _descriptions_texts;
  var config = templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.config;
  if (!config.infoSection) {
    return null;
  }
  var _config_infoSection = config.infoSection,
    badge = _config_infoSection.badge,
    title = _config_infoSection.title,
    subTitle = _config_infoSection.subTitle,
    descriptions = _config_infoSection.descriptions,
    links = _config_infoSection.links,
    buttons = _config_infoSection.buttons;
  var badgeTheme = (badge === null || badge === void 0 ? void 0 : badge.theme) ? UitkStandardBadgeThemeMap[badge.theme] : UitkBadgeStandardThemes2.EMPHASIS;
  return /* @__PURE__ */React27.createElement("div", {
    "data-view-id": (_templateComponent_metadata = templateComponent.metadata) === null || _templateComponent_metadata === void 0 ? void 0 : _templateComponent_metadata.id
  }, (badge === null || badge === void 0 ? void 0 : badge.text) && /* @__PURE__ */React27.createElement(UitkBadgeStandard, {
    text: badge.text,
    theme: badgeTheme
  }), ((title === null || title === void 0 ? void 0 : title.text) || (title === null || title === void 0 ? void 0 : title.icon)) && withSpacing(title === null || title === void 0 ? void 0 : title.spacing, /* @__PURE__ */React27.createElement(UitkHeading, {
    tag: (title === null || title === void 0 ? void 0 : (_title_attributes = title.attributes) === null || _title_attributes === void 0 ? void 0 : _title_attributes.tag) ? title.attributes.tag : "h1",
    size: (title === null || title === void 0 ? void 0 : (_title_text = title.text) === null || _title_text === void 0 ? void 0 : _title_text.size) ? UitkSizeMap[title === null || title === void 0 ? void 0 : title.text.size] : 3,
    "aria-hidden": (_title_attributes1 = title.attributes) === null || _title_attributes1 === void 0 ? void 0 : _title_attributes1.ariaHidden,
    overflow: (title === null || title === void 0 ? void 0 : title.overflow) ? UitkTextOverflowMap[title === null || title === void 0 ? void 0 : title.overflow] : void 0
  }, title.icon && /* @__PURE__ */React27.createElement(UitkIcon4, {
    name: title.icon.id,
    size: IconSizeMap[title.icon.size || "SMALL" /* SMALL */],
    title: title.icon.title || "",
    id: title.icon.id
  }), (_title_text1 = title.text) === null || _title_text1 === void 0 ? void 0 : _title_text1.text)), subTitle && subTitle.length > 0 && subTitle.map(function (sub, index) {
    var _sub_text, _sub_text1, _sub_text2, _sub_text3, _sub_text4, _sub_text5;
    var subTitleTheme = ((_sub_text = sub.text) === null || _sub_text === void 0 ? void 0 : _sub_text.theme) ? UitkThemeMap[(_sub_text1 = sub.text) === null || _sub_text1 === void 0 ? void 0 : _sub_text1.theme] : void 0;
    var subTitleWeight = ((_sub_text2 = sub.text) === null || _sub_text2 === void 0 ? void 0 : _sub_text2.weight) ? UitkWeightMap[(_sub_text3 = sub.text) === null || _sub_text3 === void 0 ? void 0 : _sub_text3.weight] : void 0;
    var subTitleSpacing = sub.space ? UitkTypeMarginMap[sub.space] : void 0;
    return /* @__PURE__ */React27.createElement(UitkText2, {
      size: ((_sub_text4 = sub.text) === null || _sub_text4 === void 0 ? void 0 : _sub_text4.size) ? UitkTextSizeMap[sub === null || sub === void 0 ? void 0 : sub.text.size] : 300,
      spacing: subTitleSpacing,
      theme: subTitleTheme,
      weight: subTitleWeight,
      key: "text-item-".concat(index),
      overflow: (sub === null || sub === void 0 ? void 0 : sub.overflow) ? UitkTextOverflowMap[sub === null || sub === void 0 ? void 0 : sub.overflow] : void 0
    }, sub.icon && /* @__PURE__ */React27.createElement(UitkIcon4, {
      name: sub.icon.id,
      size: IconSizeMap[sub.icon.size || "SMALL" /* SMALL */],
      title: sub.icon.title || "",
      id: sub.icon.id
    }), (_sub_text5 = sub.text) === null || _sub_text5 === void 0 ? void 0 : _sub_text5.text);
  }), (descriptions === null || descriptions === void 0 ? void 0 : descriptions.texts) && descriptions.texts.length > 0 && (descriptions.inheritParagraphStyling ? /* @__PURE__ */React27.createElement(React27.Fragment, null, descriptions.texts.map(function (text, index) {
    return /* @__PURE__ */React27.createElement(UitkParagraph, {
      key: "paragraph-item-".concat(index),
      size: UitkParagraphSizeMap[descriptions.paragraphSize]
    }, text);
  })) : /* @__PURE__ */React27.createElement(UitkList, {
    bullet: descriptions.showAsList ? "default" : "no-bullet",
    spacing: false
  }, (_descriptions_texts = descriptions.texts) === null || _descriptions_texts === void 0 ? void 0 : _descriptions_texts.map(function (text, index) {
    return /* @__PURE__ */React27.createElement(UitkListItem, {
      key: descriptions.showAsList ? "list-item-".concat(index) : "no-bullet-list-item-".concat(index)
    }, text);
  }))), links && links.length > 0 && /* @__PURE__ */React27.createElement(TextInfoLink, {
    config: config
  }), buttons && buttons.length > 0 && /* @__PURE__ */React27.createElement(ExperimentalButtons, {
    config: config
  }));
};
TextInfoSection.displayName = "TextInfoSection";
TextInfoSection.fragment = __TextInfoSection;
// src/library/elements/text-info-tooltip.tsx
import React39 from "react";
import { gql as gql29 } from "@apollo/client";
// ../internal/src/components/text-info-section/product-text-info-section.tsx
import React38 from "react";
import { gql as gql28 } from "@apollo/client";
import { UitkIcon as UitkIcon6, UitkIconSize as UitkIconSize5 } from "@egds/react-core/icons";
import { PositionType as PositionType2, UitkMenu as UitkMenu2, UitkMenuContainer as UitkMenuContainer2, UitkMenuTrigger as UitkMenuTrigger2 } from "@egds/react-core/menu";
import { UitkCard as UitkCard3 } from "uitk-react-cards";
import { UitkLink as UitkLink4 } from "uitk-react-link";
import { UitkMoreInfoTrigger as UitkMoreInfoTrigger2 } from "uitk-react-more-info-trigger";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
import { UitkText as UitkText8 } from "uitk-react-text";
var _obj15;
// ../internal/src/components/utils/uitk-text-utils.ts
var UitkTextWeightMap = Object.freeze((_obj15 = {}, _define_property(_obj15, "BOLD" /* BOLD */, "bold"), _define_property(_obj15, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj15, "REGULAR" /* REGULAR */, "regular"), _obj15));
var _obj16;
var UitkTextThemeMap = Object.freeze((_obj16 = {}, _define_property(_obj16, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj16, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj16, "PRIMARY" /* PRIMARY */, "emphasis"), _define_property(_obj16, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj16, "SECONDARY" /* SECONDARY */, "default"), _define_property(_obj16, "INVERSE" /* INVERSE */, "inverse"), _define_property(_obj16, "EMPHASIS" /* EMPHASIS */, "emphasis"), _obj16));
// ../internal/src/components/egds-graphic-text/egds-graphic-text.tsx
import React28 from "react";
import { gql as gql20 } from "@apollo/client";
import { EGDSMark, UitkMarkSize } from "@egds/react-core/mark";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
var fragment2 = gql20(_templateObject24(), EGDSIcon.fragment);
var EGDSGraphicText = function (param) {
  var data = param.data,
    textProps = param.textProps,
    _param_size = param.size,
    size = _param_size === void 0 ? 200 : _param_size;
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var text = data.text,
    graphic = data.graphic;
  var graphicElement = function () {
    if (graphic.__typename === "Icon") {
      return /* @__PURE__ */React28.createElement(EGDSIcon, {
        data: graphic
      });
    }
    if (graphic.__typename === "Mark") {
      var _graphic_url;
      return /* @__PURE__ */React28.createElement(EGDSSpacing, {
        padding: {
          inlineend: "two"
        }
      }, /* @__PURE__ */React28.createElement(EGDSMark, {
        url: (_graphic_url = graphic.url) === null || _graphic_url === void 0 ? void 0 : _graphic_url.value,
        size: UitkMarkSize.SMALL
      }));
    }
  };
  return /* @__PURE__ */React28.createElement(UitkText3, _object_spread({
    size: size
  }, textProps), graphicElement(), text);
};
EGDSGraphicText.fragment = fragment2;
EGDSGraphicText.displayName = "EGDSGraphicText";
// ../internal/src/components/egds-link/egds-inline-link.tsx
import React29, { useMemo } from "react";
import { gql as gql21 } from "@apollo/client";
import { UitkLink as UitkLink3 } from "uitk-react-link";
var _obj17;
// ../internal/src/components/utils/uitk-link-utils.ts
var linkSizeMapper = (_obj17 = {}, _define_property(_obj17, "SMALL" /* SMALL */, "small"), _define_property(_obj17, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj17, "LARGE" /* LARGE */, "large"), _obj17);
var _obj18;
var UILinkTargetMap = (_obj18 = {}, _define_property(_obj18, "EXTERNAL" /* EXTERNAL */, "_blank"), _define_property(_obj18, "INTERNAL" /* INTERNAL */, "_self"), _obj18);
// ../internal/src/components/egds-link/egds-inline-link.tsx
var fragment3 = gql21(_templateObject25());
var EGDSInlineLink = function (param) {
  var className = param.className,
    data = param.data,
    _param_size = param.size,
    size = _param_size === void 0 ? "medium" : _param_size,
    _param_inline = param.inline,
    inline = _param_inline === void 0 ? true : _param_inline,
    onLinkClick = param.onLinkClick,
    _param_type = param.type,
    type = _param_type === void 0 ? "link" /* LINK */ : _param_type;
  var child = useMemo(function () {
    if (!data) {
      return null;
    }
    var text = data.text,
      action = data.action;
    return /* @__PURE__ */React29.createElement(React29.Fragment, null, text, (action === null || action === void 0 ? void 0 : action.accessibility) && /* @__PURE__ */React29.createElement("span", {
      className: "is-visually-hidden"
    }, action.accessibility));
  }, [data]);
  var wrappedChildren = useMemo(function () {
    if (!data) {
      return null;
    }
    var action = data.action;
    switch (type) {
      case "button" /* BUTTON */:
        return /* @__PURE__ */React29.createElement("button", {
          type: "button"
        }, child);
      case "link" /* LINK */:
      default:
        var _action_resource;
        return /* @__PURE__ */React29.createElement("a", {
          href: action === null || action === void 0 ? void 0 : (_action_resource = action.resource) === null || _action_resource === void 0 ? void 0 : _action_resource.value,
          target: (action === null || action === void 0 ? void 0 : action.target) ? UILinkTargetMap[action.target] : void 0
        }, child);
    }
  }, [data, child, type]);
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var disabled = data.disabled,
    linkSize = data.linkSize;
  return /* @__PURE__ */React29.createElement(UitkLink3, {
    className: className,
    size: linkSize ? linkSizeMapper[linkSize] : size,
    onClickCapture: onLinkClick,
    disabled: disabled,
    inline: inline
  }, wrappedChildren);
};
EGDSInlineLink.fragment = fragment3;
EGDSInlineLink.displayName = "EGDSInlineLink";
// ../internal/src/components/egds-text/egds-spannable-text.tsx
import React34 from "react";
import { gql as gql26 } from "@apollo/client";
import { UitkText as UitkText5 } from "uitk-react-text";
// ../internal/src/components/egds-text/egds-spannable-text-content.tsx
import React33 from "react";
import { gql as gql25 } from "@apollo/client";
// ../internal/src/components/egds-heading/egds-heading.tsx
import React30 from "react";
import { gql as gql22 } from "@apollo/client";
import { EGDSHeading as EGDSReactCoreHeading } from "@egds/react-core/text";
var fragment4 = gql22(_templateObject26());
var EGDSHeading = function (props) {
  var data = props.data,
    className = props.className,
    size = props.size,
    align = props.align,
    tag = props.tag;
  var accessibility = data.accessibility,
    text = data.text;
  if (!text) {
    return null;
  }
  return /* @__PURE__ */React30.createElement(EGDSReactCoreHeading, {
    className: className,
    size: size,
    align: align,
    tag: tag,
    "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : void 0
  }, text);
};
EGDSHeading.fragment = fragment4;
EGDSHeading.displayName = "EGDSHeading";
// ../internal/src/components/egds-stylized-text/egds-stylized-text.tsx
import React31 from "react";
import { gql as gql23 } from "@apollo/client";
import { EGDSText } from "@egds/react-core/text";
var _obj19;
// ../internal/src/components/egds-stylized-text/__private/mapper.ts
var UitkThemeMap2 = Object.freeze((_obj19 = {}, _define_property(_obj19, "NEGATIVE" /* NEGATIVE */, "negative"), _define_property(_obj19, "POSITIVE" /* POSITIVE */, "positive"), _define_property(_obj19, "PRIMARY" /* PRIMARY */, "emphasis"), _define_property(_obj19, "SECONDARY" /* SECONDARY */, "default"), _define_property(_obj19, "LOYALTY" /* LOYALTY */, "loyalty"), _define_property(_obj19, "INVERSE" /* INVERSE */, "inverse"), _define_property(_obj19, "default", "default"), _obj19));
var _obj20;
var UitkWeightMap2 = Object.freeze((_obj20 = {}, _define_property(_obj20, "BOLD" /* BOLD */, "bold"), _define_property(_obj20, "MEDIUM" /* MEDIUM */, "medium"), _define_property(_obj20, "REGULAR" /* REGULAR */, "regular"), _obj20));
var UitkSizeMap2 = Object.freeze({
  "100": 100,
  "200": 200,
  "300": 300,
  "400": 400,
  "500": 500,
  "600": 600,
  "700": 700,
  "800": 800,
  "900": 900
});
var DecorativeMap = Object.freeze({
  HIGHLIGHT: "mark",
  LINE_THROUGH: "s",
  SUBSCRIPT: "sub",
  SUPERSCRIPT: "sup",
  UNDERLINE: "u"
});
// ../internal/src/components/egds-stylized-text/egds-stylized-text.tsx
var fragment5 = gql23(_templateObject27());
var EGDSStylizedText = function (_param) {
  var data = _param.data,
    _param_theme = _param.theme,
    theme = _param_theme === void 0 ? "default" : _param_theme,
    _param_weight = _param.weight,
    weight = _param_weight === void 0 ? "regular" : _param_weight,
    _param_size = _param.size,
    size = _param_size === void 0 ? 300 : _param_size,
    props = _object_without_properties(_param, ["data", "theme", "weight", "size"]);
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var text = data.text,
    decorative = data.decorative,
    accessibility = data.accessibility;
  var textProps = _object_spread({
    theme: (data === null || data === void 0 ? void 0 : data.theme) ? UitkThemeMap2[data.theme] : theme,
    weight: (data === null || data === void 0 ? void 0 : data.weight) ? UitkWeightMap2[data.weight] : weight,
    size: (data === null || data === void 0 ? void 0 : data.size) ? UitkSizeMap2[data.size] : size
  }, props);
  var Decorative = decorative && DecorativeMap[decorative];
  var content = Decorative ? /* @__PURE__ */React31.createElement(Decorative, null, text) : text;
  return /* @__PURE__ */React31.createElement(React31.Fragment, null, /* @__PURE__ */React31.createElement(EGDSText, _object_spread({
    "aria-hidden": Boolean(accessibility)
  }, textProps), content), accessibility && /* @__PURE__ */React31.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
EGDSStylizedText.fragment = fragment5;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/egds-text/egds-plain-text.tsx
import React32 from "react";
import { gql as gql24 } from "@apollo/client";
import { UitkText as UitkText4 } from "uitk-react-text";
var fragment6 = gql24(_templateObject28());
var EGDSPlainText = function (param) {
  var className = param.className,
    inline = param.inline,
    size = param.size,
    align = param.align,
    data = param.data,
    spacing = param.spacing;
  if (!(data === null || data === void 0 ? void 0 : data.text)) {
    return null;
  }
  var text = data.text,
    accessibility = data.accessibility;
  return /* @__PURE__ */React32.createElement(UitkText4, {
    className: className,
    inline: inline,
    size: size,
    align: align,
    spacing: spacing
  }, text, accessibility && /* @__PURE__ */React32.createElement("span", {
    className: "is-visually-hidden"
  }, accessibility));
};
EGDSPlainText.fragment = fragment6;
EGDSPlainText.displayName = "EGDSPlainText";
// ../internal/src/components/egds-text/egds-spannable-text-content.tsx
var fragment7 = gql25(_templateObject29(), EGDSHeading.fragment, EGDSStylizedText.fragment, EGDSPlainText.fragment, EGDSGraphicText.fragment);
var EGDSSpannableTextContent = function (param) {
  var className = param.className,
    size = param.size,
    headingProps = param.headingProps,
    data = param.data,
    inline = param.inline;
  switch (data.__typename) {
    case "EGDSHeading":
      return /* @__PURE__ */React33.createElement(EGDSHeading, _object_spread({
        data: data
      }, headingProps));
    case "EGDSStylizedText":
      return /* @__PURE__ */React33.createElement(EGDSStylizedText, {
        className: className,
        data: data,
        size: size,
        inline: inline
      });
    case "EGDSPlainText":
      return /* @__PURE__ */React33.createElement(EGDSPlainText, {
        className: className,
        data: data,
        size: size,
        inline: inline
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React33.createElement(EGDSGraphicText, {
        data: data,
        size: size
      });
    default:
      return null;
  }
};
EGDSSpannableTextContent.fragment = fragment7;
EGDSSpannableTextContent.displayName = "EGDSSpannableTextContent";
// ../internal/src/components/egds-text/egds-spannable-text.tsx
var fragment8 = gql26(_templateObject30(), EGDSSpannableTextContent.fragment);
var EGDSSpannableText = function (props) {
  var _data_inlineContent;
  var align = props.align,
    data = props.data,
    styleProps = _object_without_properties(props, ["align", "data"]);
  if (data === null || data === void 0 ? void 0 : (_data_inlineContent = data.inlineContent) === null || _data_inlineContent === void 0 ? void 0 : _data_inlineContent.length) {
    return /* @__PURE__ */React34.createElement(React34.Fragment, null, data.inlineContent.map(function (item, index) {
      return /* @__PURE__ */React34.createElement(EGDSSpannableTextContent, _object_spread_props(_object_spread({
        data: item
      }, styleProps), {
        key: "spannable-item-".concat(index)
      }));
    }));
  }
  if (data === null || data === void 0 ? void 0 : data.text) {
    return /* @__PURE__ */React34.createElement(UitkText5, _object_spread_props(_object_spread({}, styleProps), {
      inline: true,
      align: align
    }), data.text);
  }
  return null;
};
EGDSSpannableText.fragment = fragment8;
EGDSSpannableText.displayName = "EGDSSpannableText";
// ../internal/src/components/text-info-section/product-text-info-content.tsx
import React35 from "react";
import { gql as gql27 } from "@apollo/client";
var fragment9 = gql27(_templateObject31(), EGDSInlineLink.fragment, EGDSPlainText.fragment, EGDSGraphicText.fragment);
var ProductTextInfoContent = function (param) {
  var className = param.className,
    size = param.size,
    data = param.data,
    inline = param.inline,
    index = param.index,
    handleClick = param.handleClick;
  switch (data.__typename) {
    case "EGDSPlainText":
      return /* @__PURE__ */React35.createElement(EGDSPlainText, {
        className: className,
        data: data,
        size: size,
        inline: inline,
        spacing: index === 0 ? void 0 : "three"
      });
    case "EGDSInlineLink":
      return /* @__PURE__ */React35.createElement(EGDSInlineLink, {
        data: data,
        size: "medium",
        inline: false,
        onLinkClick: handleClick
      });
    case "EGDSGraphicText":
      return /* @__PURE__ */React35.createElement(EGDSGraphicText, {
        data: data,
        size: size
      });
    default:
      return null;
  }
};
ProductTextInfoContent.fragment = fragment9;
ProductTextInfoContent.displayName = "ProductTextInfoContent";
// ../internal/src/components/text-info-section/render-legacy.tsx
import React37 from "react";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize4 } from "@egds/react-core/icons";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "@egds/react-core/menu";
import { UitkMoreInfoTrigger } from "uitk-react-more-info-trigger";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
import { UitkText as UitkText7 } from "uitk-react-text";
// ../internal/src/components/text-info-section/policy-tooltip-section.tsx
import React36 from "react";
import { UitkCard as UitkCard2 } from "uitk-react-cards";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkText as UitkText6 } from "uitk-react-text";
var PolicyTooltipSection = function (param) {
  var data = param.data;
  return /* @__PURE__ */React36.createElement(UitkSpacing5, {
    padding: {
      inline: "three"
    }
  }, /* @__PURE__ */React36.createElement(UitkCard2, null, data.map(function (item, index) {
    return /* @__PURE__ */React36.createElement(UitkText6, {
      key: "tooltip-text-".concat(index),
      size: 300,
      spacing: index === 0 ? void 0 : "six"
    }, item);
  })));
};
PolicyTooltipSection.displayName = "PolicyTooltipSection";
// ../internal/src/components/text-info-section/render-legacy.tsx
var renderSection = function (param) {
  var tooltipIcon = param.tooltipIcon,
    tooltipContent = param.tooltipContent,
    title = param.title,
    policyA11yText = param.policyA11yText,
    isMenuOpen = param.isMenuOpen,
    toggleMenuOpen = param.toggleMenuOpen;
  return /* @__PURE__ */React37.createElement(UitkSpacing6, {
    margin: {
      blockstart: "one"
    }
  }, tooltipIcon ? /* @__PURE__ */React37.createElement(UitkMenu, {
    isOpen: isMenuOpen,
    onTriggerClick: toggleMenuOpen
  }, /* @__PURE__ */React37.createElement(UitkMenuTrigger, null, /* @__PURE__ */React37.createElement(UitkMoreInfoTrigger, {
    theme: tooltipIcon.theme || void 0
  }, /* @__PURE__ */React37.createElement("button", {
    type: "button",
    "aria-label": policyA11yText !== null && policyA11yText !== void 0 ? policyA11yText : void 0
  }, /* @__PURE__ */React37.createElement("span", null, title.text), /* @__PURE__ */React37.createElement(UitkIcon5, {
    name: tooltipIcon.id,
    size: tooltipIcon.size ? UitkIconSize4[tooltipIcon.size] : void 0
  })))), tooltipContent && /* @__PURE__ */React37.createElement(UitkMenuContainer, {
    autoPosition: true,
    position: PositionType.LEFT,
    width: 327
  }, /* @__PURE__ */React37.createElement(PolicyTooltipSection, {
    data: tooltipContent
  }))) : /* @__PURE__ */React37.createElement("div", null, /* @__PURE__ */React37.createElement(UitkText7, {
    size: 300,
    theme: title.theme ? UitkTextThemeMap[title.theme] : void 0,
    weight: title.weight ? UitkTextWeightMap[title.weight] : void 0,
    "aria-hidden": Boolean(title.accessibility)
  }, title.text), title.accessibility && /* @__PURE__ */React37.createElement("span", {
    className: "is-visually-hidden"
  }, title.accessibility)));
};
// ../internal/src/components/text-info-section/product-text-info-section.tsx
var __ProductTextInfoSection = gql28(_templateObject32(), EGDSInlineLink.fragment, EGDSPlainText.fragment, EGDSGraphicText.fragment);
var ProductTextInfoSection = function (param) {
  var data = param.data,
    handleTooltipLoad = param.handleTooltipLoad,
    trackTooltipToggle = param.trackTooltipToggle,
    _param_shouldShowLink = param.shouldShowLink,
    shouldShowLink = _param_shouldShowLink === void 0 ? false : _param_shouldShowLink,
    textSize = param.textSize,
    trackTextInfoContentLinkClick = param.trackTextInfoContentLinkClick;
  var _React38_useState = _sliced_to_array(React38.useState(false), 2),
    isMenuOpen = _React38_useState[0],
    setIsMenuOpen = _React38_useState[1];
  var pushEvent = React38.useRef(true);
  var pushTooltipSelectedEvent = React38.useRef(true);
  var pushTooltipHiddenEvent = React38.useRef(true);
  var title = data.title,
    tooltipContent = data.tooltipContent,
    tooltipIcon = data.tooltipIcon,
    policyA11yText = data.policyA11yText;
  var toggleMenuOpen = function () {
    if ((pushTooltipSelectedEvent.current || pushTooltipHiddenEvent.current) && trackTooltipToggle) {
      trackTooltipToggle(title === null || title === void 0 ? void 0 : title.text, isMenuOpen);
    }
    setIsMenuOpen(function (prevState) {
      return !prevState;
    });
  };
  if (data.message) {
    var _message_content;
    var icon = data.icon,
      message = data.message,
      accessibilityText = data.accessibilityText,
      theme = data.theme;
    var menuLabel = function () {
      return /* @__PURE__ */React38.createElement(UitkMenuTrigger2, null, shouldShowLink ? /* @__PURE__ */React38.createElement(UitkLink4, null, /* @__PURE__ */React38.createElement("button", {
        type: "button",
        "aria-label": accessibilityText !== null && accessibilityText !== void 0 ? accessibilityText : void 0
      }, /* @__PURE__ */React38.createElement("span", null, title.text), icon && /* @__PURE__ */React38.createElement(UitkIcon6, {
        name: icon.id,
        size: icon.size ? UitkIconSize5[icon.size] : void 0
      }))) : /* @__PURE__ */React38.createElement(UitkMoreInfoTrigger2, {
        theme: theme
      }, /* @__PURE__ */React38.createElement("button", {
        type: "button",
        "aria-label": accessibilityText !== null && accessibilityText !== void 0 ? accessibilityText : void 0
      }, /* @__PURE__ */React38.createElement("span", null, title.text), icon && /* @__PURE__ */React38.createElement(UitkIcon6, {
        name: icon.id,
        size: icon.size ? UitkIconSize5[icon.size] : void 0
      }))));
    };
    if (icon && message && pushEvent.current && handleTooltipLoad) {
      pushEvent.current = false;
      handleTooltipLoad(title.text);
    }
    return /* @__PURE__ */React38.createElement(UitkSpacing7, {
      margin: {
        blockstart: "one"
      }
    }, icon ? /* @__PURE__ */React38.createElement(UitkMenu2, {
      isOpen: isMenuOpen,
      onTriggerClick: toggleMenuOpen
    }, menuLabel(), (message === null || message === void 0 ? void 0 : message.content) && (message === null || message === void 0 ? void 0 : message.content.length) > 0 && /* @__PURE__ */React38.createElement(UitkMenuContainer2, {
      autoPosition: true,
      position: PositionType2.LEFT,
      width: 327
    }, /* @__PURE__ */React38.createElement(UitkSpacing7, {
      padding: {
        inline: "three"
      }
    }, /* @__PURE__ */React38.createElement(UitkCard3, null, message === null || message === void 0 ? void 0 : (_message_content = message.content) === null || _message_content === void 0 ? void 0 : _message_content.map(function (item, index) {
      return /* @__PURE__ */React38.createElement(ProductTextInfoContent, {
        data: item,
        key: index,
        index: index,
        size: textSize,
        handleClick: trackTextInfoContentLinkClick
      });
    }))))) : /* @__PURE__ */React38.createElement("div", null, /* @__PURE__ */React38.createElement(UitkText8, {
      size: 300,
      theme: UitkTextThemeMap[title.theme || "SECONDARY" /* SECONDARY */],
      weight: UitkTextWeightMap[title.weight || "REGULAR" /* REGULAR */],
      "aria-hidden": Boolean(title.accessibility)
    }, title.text), title.accessibility && /* @__PURE__ */React38.createElement("span", {
      className: "is-visually-hidden"
    }, title.accessibility)));
  }
  return renderSection({
    tooltipIcon: tooltipIcon,
    tooltipContent: tooltipContent,
    title: title,
    policyA11yText: policyA11yText,
    isMenuOpen: isMenuOpen,
    toggleMenuOpen: toggleMenuOpen
  });
};
ProductTextInfoSection.displayName = "ProductTextInfoSection";
ProductTextInfoSection.fragment = _object_spread_props(_object_spread({}, __ProductTextInfoSection), {
  __typename: "ProductTextInfoSection"
});
// src/library/elements/text-info-tooltip.tsx
var __TextInfoTooltipFragment = gql29(_templateObject33(), ProductTextInfoSection.fragment);
var TextInfoTooltip = function (param) {
  var templateComponent = param.templateComponent;
  var _templateComponent_metadata;
  var config = templateComponent === null || templateComponent === void 0 ? void 0 : templateComponent.config;
  var textIconTooltip = config.textIconTooltip;
  return /* @__PURE__ */React39.createElement(ProductTextInfoSection, {
    "data-view-id": (_templateComponent_metadata = templateComponent.metadata) === null || _templateComponent_metadata === void 0 ? void 0 : _templateComponent_metadata.id,
    data: textIconTooltip
  });
};
TextInfoTooltip.displayName = "TextInfoTooltipWrapper";
TextInfoTooltip.fragment = __TextInfoTooltipFragment;
// src/library/index.ts
var experimentalElementsLibrary = /* @__PURE__ */new Map().set("Card" /* Card */, Card).set("InfoSection" /* InfoSection */, TextInfoSection).set("Grid" /* Grid */, LayoutGrid).set("Carousel" /* Carousel */, Carousel).set("Spacing" /* Spacing */, Spacing).set("Rating" /* Rating */, Rating).set("Expando" /* Expando */, Expando).set("IntersectionTracker" /* IntersectionTracker */, Intersection).set("TextIconTooltip" /* TextIconTooltip */, TextInfoTooltip).set("Tabs" /* Tabs */, Tabs).set("Modal" /* Modal */, Modal).set("Media" /* Media */, Media).set("Script" /* Script */, Script).set("Container" /* Container */, Container);
var componentLibrary = new Map(_to_consumable_array(experimentalElementsLibrary));
// src/components/random-access-one/__private/__fragments/experimental-config.tsx
import React40 from "react";
import { gql as gql30 } from "@apollo/client";
var __ExperimentalConfigFragment = gql30(_templateObject34(), Card.fragment, Spacing.fragment, TextInfoSection.fragment, Carousel.fragment, LayoutGrid.fragment, Rating.fragment, Expando.fragment, Intersection.fragment, TextInfoTooltip.fragment, Tabs.fragment, Modal.fragment, Media.fragment, ExperimentalScript.fragment, Container.fragment);
var ExperimentalConfig = function () {
  return /* @__PURE__ */React40.createElement("div", null, "ExperimentalConfig.fragment");
};
ExperimentalConfig.displayName = "ExperimentalConfig";
ExperimentalConfig.fragment = __ExperimentalConfigFragment;
// src/components/random-access-one/random-access-one.tsx
import { ExperienceTemplateRenderer as ExperienceTemplateRenderer11, ExperienceTemplateRendererContextProvider } from "experience-template-renderer-react";
var __Query = gql31(_templateObject35(), ExperimentalConfig.fragment);
var render = function (components) {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    /* @__PURE__ */
    React41.createElement(ExperienceTemplateRendererContextProvider, {
      library: componentLibrary
    }, /* @__PURE__ */React41.createElement(ExperienceTemplateRenderer11, {
      templateComponents: components
    }))
  );
};
var RandomAccessOneFetch = function (props) {
  var _data_randomAccessOne, _data_randomAccessOne1;
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    batchKey = props.batchKey,
    loadingPlaceholder = props.loadingPlaceholder,
    renderOverride = props.renderOverride;
  var context = useBexApi().context;
  var DEFAULT_BATCH_KEY = "default-random-access-experience-batch-key";
  var adaptexImage = inputs.featureId.includes("image_mosaic_adaptex");
  var setAdaptExState = useContext2(ProductGalleryContext2).setAdaptExState;
  var variables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  var _useQuery = useQuery(__Query, {
      context: {
        useApq: true,
        batchKey: batchKey !== null && batchKey !== void 0 ? batchKey : DEFAULT_BATCH_KEY
      },
      variables: variables,
      ssr: !skipSsr
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading;
  handleAdaptexEvents(inputs.featureId, data);
  if (loading) {
    return loadingPlaceholder || null;
  }
  var isEmptyMapping = !(data === null || data === void 0 ? void 0 : (_data_randomAccessOne = data.randomAccessOne) === null || _data_randomAccessOne === void 0 ? void 0 : _data_randomAccessOne.mapping) || !(data === null || data === void 0 ? void 0 : (_data_randomAccessOne1 = data.randomAccessOne) === null || _data_randomAccessOne1 === void 0 ? void 0 : _data_randomAccessOne1.mapping.length);
  if (error || isEmptyMapping) {
    if (adaptexImage) {
      setAdaptExState(true);
    }
    return null;
  }
  if (renderOverride) {
    return renderOverride;
  }
  var components = toTemplateResponse(data);
  return render(components);
};
RandomAccessOneFetch.displayName = "sharedui-RandomAccessOneFetch";
var RandomAccessOne = function (props) {
  var mockData = props.mockData;
  if (mockData) {
    var components = toTemplateResponse(mockData);
    return render(components);
  }
  return /* @__PURE__ */React41.createElement(RandomAccessOneFetch, _object_spread({}, props));
};
RandomAccessOne.displayName = "sharedui-RandomAccessOne";
export { ExperimentalElements, IdentifierType, RandomAccessOne, __Query, toTemplateResponse }; /* istanbul ignore next -- @preserve */ /* istanbul ignore file -- @preserve */